export const products = [
  { id: 1, name: 'Soft Pinch Liquid Blush',
    category: 'Rubores', formato: 'Líquido',
    brand: 'Rare Beauty', gama: 'Media Alta',
    price: 680, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - 7.5ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/2f/c5/2f/2fc52fddb15ba2039d7d9f8555b7d2a5.jpg',
    shades:[
        {
        name: 'Happy', color: '#F986A7', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-HAPPY.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-HAPPY_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Worth', color: '#CF7672', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-WORTH.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-WORTH_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Hope', color: '#DE8F86', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-HOPE.jpg?v=1762200490',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-HOPE_1440x.jpg?v=1772745266&format=pjpg'
        },
        {
        name: 'Virtue', color: '#E7806A', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-VIRTUE.jpg?v=1764180906',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-VIRTUE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Resilence', color: '#9d4532', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-RESILIENCE.jpg?v=1764180906',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-RESILIENCE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Adore', color: '#ee9091', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-ADORE.jpg?v=1764180906',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-ADORE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Joy', color: '#FF7158', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-JOY.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-JOY_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Love', color: '#C2423E', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-MATTE-LOVE.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-MATTE-LOVE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Encourage', color: '#C76F7B', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-ENCOURAGE.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-ENCOURAGE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Grace', color: '#CC5979', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-MATTE-GRACE.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-MATTE-GRACE_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Grateful', color: '#D9233E', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-GRATEFUL.jpg?v=1764122517',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-GRATEFUL_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Bliss', color: '#E4847E', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-MATTE-BLISS_1440x.jpg?v=1727895258&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-MATTE-BLISS_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Lucky', color: '#FF558B', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-LUCKY_1440x.jpg?v=1764122517&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-LUCKY_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Believe', color: '#B7666F', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIQUID-BLUSH-DEWY-BELIEVE_1440x.jpg?v=1764122517&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-BELIEVE_1440x.jpg?v=1764180906&format=pjpg'
        },
  ]},
  {id: 2, name: 'Pocket Blush ',
    category: 'Rubores', formato: 'Crema',
    brand: 'Rhode ', gama: 'Alta',
    price: 740, oldPrice: 645,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '5.3 gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/e7/e2/99/e7e2991cba2428827887f059e0b70f5f.jpg',
    shades:[
        {
        name: 'Piggy', color: '#F986A7', stock: true,
        image: 'https://www.rhodeskin.com/cdn/shop/files/Piggy-Hero-4_Desktop_d131a90c-169b-43ed-b34d-9e18c791b664_2480x.jpg?v=1717787526',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896181-av-2202507250951014570700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Toasted Teddy', color: '#82312a', stock: true,
        image: 'https://www.rhodeskin.com/cdn/shop/files/ToastedTeddy-Hero-4_Desktop_2480x.jpg?v=1717787526',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895969-av-2202507250910054490700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sprinkle', color: '#DA6371', stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/sprinkle-duo-hero-3_2480x.jpg?v=1719001731',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896033-av-2202508150822392870700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sleepy Girl', color: '#AC4746',stock: true,
        image: 'https://www.rhodeskin.com/cdn/shop/files/SleepyGirl-Hero-4_Desktop_edff6bf5-da2a-478a-af41-de9b57924606_2480x.jpg?v=1717787526',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895845-av-2202507250642211930700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Candy Apple', color: 'rgb(214, 0, 28)', stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/candy-apple-carousel-3_2480x.jpg?v=1772090438',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2998110-av-2202605131730536620700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Teacup', color: '#D34F5D', stock: true,
        image: 'https://www.rhodeskin.com/cdn/shop/files/teacup-featured_2480x.jpg?v=1772177714',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2998102-av-2202605131739355790700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tan Line', color: '#BC6B6B', stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/tanline-hero3-desktop_77d055c2-4e3f-498c-9e1a-647674a2728c_2480x.jpg?v=1765924687',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2916823-av-2202507250754161630700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Date Cake',color: '#861B38',stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/DateCake-Hero_Desktop_2480x.jpg?v=1741820637',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896116-av-2202508072217272000700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sun Soak',color: '#EE7A61',stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/sunsoak-hero3-desktop_ed2b590c-4727-4d69-8b20-df17246fb1be_2480x.jpg?v=1751327670',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2916815-av-2202507250809165600700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Freckle', color: '#D17A6F', stock: true,
        image: 'https://www.rhodeskin.com/cdn/shop/files/Freckle-Hero-4_Desktop_2480x.jpg?v=1717787526',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896124-av-2202507250847585410700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Juice Box', color: '#F65476', stock: false,
        image: 'https://www.rhodeskin.com/cdn/shop/files/JuiceBox-Hero-4_Desktop_f2f60428-e840-4f59-873e-fee5c047d8d2_2480x.jpg?v=1717787526',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895779-av-2202508080828353620700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 3, name: 'Major Blush Duo',
    category: 'Rubores', formato: 'Polvo & Crema',
    brand: 'Patrick Ta ', gama: 'Alta',
    price: 1150, oldPrice: 995,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Full - 2 x 5gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/b3/be/8f/b3be8f03019bb7cc3c8c23ac9f2fb600.jpg',
    shades:[
        {
        name: 'She goes to the gym', color: '#AA4D4C',stock: true,
        image: 'https://patrickta.com/cdn/shop/files/P-Page-Blush-Swatches-She-Goes-To-The-Gym_1.jpg?v=1754426761&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Goes_To_The_Gym_2.jpg?v=1754426761&width=1800'
        },
        {
        name: 'Shes that girl', color: '#FC5A73', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesThatGirl-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesThatGirl-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She left me on red', color: '#D6001C', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/P-Page-Blush-Swatches-She-Left-Me-On-Red.jpg?v=1754074474&width=2000',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Left_Me_On_Red_1.jpg?v=1754074474&width=1200'
        },
        {
        name: 'Oh she´s different', color: '#BA3A45', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-OhShesDiff-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-OhShesDiff-av-03_55664fe6-bfb8-4a93-9538-f3c95be59f93.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s Wanted', color: '#C50052', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesWanted-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesWanted-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She Knows Who She Is', color: '#6B2B29',stock: true,
        image: 'https://patrickta.com/cdn/shop/files/P-Page-Blush-Swatches-She-Knows-Who-She-Is.jpg?v=1754074474&width=2000',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Knows_Who_She_Is_1.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s Seductive', color: '#BC7973', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/P-Page-Blush-Swatches-She_s-Seducitve.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_s_Seductive_1.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s a Doll', color: '#FD6091', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesADoll-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/image_1.jpg?v=1784669775&width=1200'
        },
        {
        name: 'She´s Baked', color: '#BB292B',stock: true,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo_ShesBaked-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuo_ShesBaked-av-01_73b9a698-5307-4455-83dc-bd024ab8c175.jpg?v=1754074474&width=2000'
        },
        {
        name: 'She´s Vibrant', color: '#FE2F42', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesVibrant-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesVibrant-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s Blushing', color: '#CF6252', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesBlushing-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesBlushing-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s Flushed',color: '#C84146', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesFlushed-av-02.jpg?v=1754074474&width=2000',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesFlushed-av-03.jpg?v=1754074474&width=2000'
        },
        {
        name: 'She´s so LA', color: '#BE5635', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesSoLA-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesSoLA-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s the moment', color: '#F97B65', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesTheMoment-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesTheMoment-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'Not Too Much', color: '#D17F73', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-NotTooMuch-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-NotTooMuch-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'Just Enough', color: '#FDA6CA', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-JustEnough-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-JustEnough-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'Soft Launch', color: '#FD5949', stock: false,
        image: 'https://patrickta.com/cdn/shop/files/2925980-av-1_e6da69d3-96b8-403f-999e-ebd6df9706f1.png?v=1767886804&width=2000',
        swatchImage: 'https://patrickta.com/cdn/shop/files/2925980-av-2_c8c1de61-3e47-4eea-93b2-8a80104e0af9.jpg?v=1767886804&width=2000'
        },
        {
        name: 'She´s Giving', color: '#FF4E9C',stock: false,
        image: 'https://patrickta.com/cdn/shop/files/BlushDuo-PDP-ShesGiving-av-02.jpg?v=1754074474&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesGiving-av-03.jpg?v=1754074474&width=2000'
        },
  ]},
  {id: 4, name: 'Mini Soft Pinch Liquid Blush',
    category: 'Rubores', formato: 'Líquido', 
    brand: 'Rare Beauty', gama: 'Media Alta',
    price: 490, oldPrice: 440,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini Size - 3.2ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/52/87/29/528729fb1ff9bec6d9a0d0126dbb4b60.jpg ',
    shades:[
        {
        name: 'Hope', color: '#E98993', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SOFT-PINCH-LIQUID-BLUSH-HOPE-PRODUCT-BOX_1440x.jpg?v=1762289029&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-HOPE_1440x.jpg?v=1772745266&format=pjpg'
        },
        {
        name: 'Happy',color: '#F986A7', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SOFT-PINCH-LIQUID-BLUSH-HAPPY-PRODUCT-BOX_1440x.jpg?v=1712037928&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-HAPPY_1440x.jpg?v=1764180906&format=pjpg'
        },
        {
        name: 'Wonder', color: '#AC4D51', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SP-LIQUID-BLUSH-WONDER-PRODUCT-BOX_1440x.jpg?v=1748378724&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-WONDER_1440x.jpg?v=1748378724&format=pjpg'
        },
        {
        name: 'Charm', color: '#FF746F', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SP-LIQUID-BLUSH-CHARM-PRODUCT-BOX_1440x.jpg?v=1748378724&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-CHARM_1440x.jpg?v=1748378724&format=pjpg'
        },
        {
        name: 'Forever', color: '#C0795F', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-FOREVER-GALLERYwBOX-1440x1952_1440x.jpg?v=1783987577&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-FOREVER-GRID-1440x1952_1440x.png?v=1783987577'
        },
        {
        name: 'Enamored', color: '#F4337A',stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-ENAMORED-GALLERYwBOX-1440x1952_1440x.jpg?v=1783987379&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-ENAMORED-GRID-1440x1952_1440x.png?v=1783987379'
        },
        {
        name: 'Daydream', color: '#D47386',stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-DAYDREAM-GALLERYwBOX-1440x1952_1440x.jpg?v=1783987509&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-DAYDREAM-GRID-1440x1952_1440x.png?v=1783987509'
        },
        {
        name: 'Intrigue', color: '#FA3556', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-INTRIGUE-GALLERYwBOX-1440x1952_1440x.jpg?v=1783987266&format=pjpg',
        swatchImage: 'https://www.rarebeauty.com/cdn/shop/files/MINI-SPLB-EXT-INTRIGUE-GRID-1440x1952_1440x.png?v=1783987267'
        },
        {
        name: 'Charisma', color: '#D02760', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-CHARISMA-GALLERYwBOX-1440x1952_1440x.jpg?v=1783987653&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/MINI-SPLB-EXT-CHARISMA-GRID-1440x1952_1440x.png?v=1783987654'
        },
        {
        name: 'Spirited', color: '#B46489',stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SP-LIQUID-BLUSH-SPIRITED-PRODUCT-BOX_1440x.jpg?v=1748378724&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-SPIRITED_1440x.jpg?v=1748378724&format=pjpg'
        },
        {
        name: 'Faith', color: '#872D50', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SP-LIQUID-BLUSH-FAITH-PRODUCT-BOX_1440x.jpg?v=1748378724&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-MATTE-FAITH_1e817eb1-09ea-4469-8b79-64f8ecd0536f_1440x.jpg?v=1748378724&format=pjpg'
        },
        {
        name: 'Joy', color: '#FF7158', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-MINI-SOFT-PINCH-LIQUID-BLUSH-JOY-PRODUCT-BOX_1440x.jpg?v=1748551467&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIQUID-BLUSH-DEWY-JOY_1440x.jpg?v=1764180906&format=pjpg'
        },
  ]},
  {id: 5, name: 'Peptide Lip Tint',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Rhode', gama: 'Media Alta',
    price: 600, oldPrice: 520,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '10ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.rhodeskin.com/cdn/shop/files/tint-bundle-hero-desktop_2480x.jpg?v=1772559937 ',
    shades:[
        {
        name: 'Raspberry Jelly', color: '#A33160', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2896082-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/Mobile-RaspberryJellyGrid-1_1024x.jpg?v=1762221075'
        },
        {
        name: 'Espresso', color: '#683F34', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2896132-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/Mobile-EspressoGrid-1_640x.jpg?v=1762221035'
        },
        {
        name: 'PBJ', color: '#823B34', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2896009-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/Mobile-pbj-Grid-1_1024x.jpg?v=1742267341'
        },
        {
        name: 'Salty Tan', color: '#B06F76', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895936-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/salty-tan-hero3-mobille_1024x.jpg?v=1755974338'
        },
        {
        name: 'Jelly Bean', color: '#E99BC3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895761-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/jelly-bean-hero3-mobile_1024x.jpg?v=1755809124'
        },
        {
        name: 'Ribbon', color: '#E37998', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2895993-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/Mobile-RibbonGrid-1_5112626c-a659-447d-bde7-b24e60b87cd4_960x.jpg?v=1762221133'
        },
        {
        name: 'Toast', color: '#b37368', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2896090-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/Mobile-ToastGrid-1_1024x.jpg?v=1762221107'
        },
        {
        name: 'Pretzel', color: '#B57081', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3025855-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.rhodeskin.com/cdn/shop/files/pretzel-hero3-4grid-mobile_22f5fc68-cd1d-4b92-8b25-a02997b08b11_640x.jpg?v=1790629871'
        },
  ]},
  {id: 6, name: 'Glow Reviver Lip Oil',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'ELF', gama: 'Media',
    price: 270, oldPrice: 250,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true, ss:false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F34401d5a4f21469a9be21fb9dc95e6a4%2F239cedf912b4402aada4b1c34343b88f?width=900&quality=85&format=webp',
    shades:[
        {
        name: 'Pink Quartz', color: '#F48CA2', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82004_OpenA_V7_R_1005c717-0347-4eed-ba9f-3cefb6bd5bdf.png?v=1780264231&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_PinkQuartz.jpg?v=1780264231&width=2880&height=2880&crop=center'
        },
        {
        name: 'Honey Talks', color: '#834f42', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82005_OpenA_R_2dfb2d2c-4cea-4df7-9f01-851eba04e145.png?v=1780264224&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_HoneyTalks.jpg?v=1780264224&width=2880&height=2880&crop=center'
        },
        {
        name: 'Rose Envy', color: '#c83841', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82006_OpenA_R_716ea6b8-6db6-470d-8d0c-e806cfccc350.png?v=1780264216&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_RoseEnvy.jpg?v=1780264215&width=1440&height=1440&crop=center'
        },
        {
        name: 'Jam Session', color: '#882b33', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82009_OpenA_R_4d5ef669-eb01-4ede-b4e6-0acf1ab65ef3.png?v=1780264191&width=2880&height=2880&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_JamSession.jpg?v=1780264191&width=1440&height=1440&crop=center'
        },
        {
        name: 'Red Delicious', color: '#D6001C', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82008_OpenA_R_9c95e94c-4843-4d77-948a-5216098759fb.png?v=1780264200&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_RedDelicious.jpg?v=1780264200&width=1440&height=1440&crop=center'
        },
        {
        name: 'Money Mauve', color: '#7b4a4d', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82012_OPENA_v5_R_4cc5eb4e-da23-43ba-ac05-7080a1e24c06.png?v=1780264176&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_MoneyMauve.jpg?v=1780264176&width=1440&height=1440&crop=center'
        },
        {
        name: 'It´s Giving Guava', color: '#cc5f5a', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82013_OPENA_v5_R_2fb5e6e7-d342-4425-b7a3-07361f3bc76a.png?v=1780264169&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_ItsGivingGuava.jpg?v=1780264169&width=1440&height=1440&crop=center'
        },
        {
        name: 'Hot As Fudge', color: '#7b4a4d', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82014_OPENA_v5_R_a08e1cc1-805d-4d18-bf6e-1aaa8120003a.png?v=1780264162&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_HotAsFudge.jpg?v=1780264162&width=2880&height=2880&crop=center'
        },
        {
        name: 'Crystal Clear', color: '#ffff', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/82010_OpenA_R_3562d96f-5743-451c-890c-1b502754eb7b.png?v=1780264184&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/1225_EDU_LIPOIL_ShadeSpotlight_CrystalClear.jpg?v=1780264183&width=2880&height=2880&crop=center'
        },
        {
        name: 'Jelly Pop (Ed. Limitada)', color: '#F73371', stock: true,
        image: 'https://i.pinimg.com/1200x/67/8d/81/678d8122a67402cc6a012b4ce3ba72ff.jpg',
        swatchImage: 'https://i.pinimg.com/1200x/ce/2f/1e/ce2f1e6e726f70d7bea95d2dd4c450db.jpg'
        },
  ]},
  {id: 7, name: 'Backstage Glow Face Palette',
    category:'Iluminadores', formato: 'Polvo',
    brand: 'Dior',gama: 'Lujo',
    price: 1550, oldPrice: 1260,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '10gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://i.pinimg.com/1200x/a4/5b/48/a45b4850c24c6941c35a5ba2ba0957cb.jpg',
    shades:[
        {
        name: '001 Universal Glow', color: '#CC889B', stock: true,
        image: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dw497a8164/Y0000104/Y0000104_E000000579_E01_RHC.jpg?sw=1280',
        swatchImage: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dw6c6576a4/Y0000104/Y0000104_E000000579_E03_RHC.jpg?sw=1280'
        },
        {
        name: '003 Pearly Peach Glow', color: '#E49088', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw08bface2/Y0000104/Y0000104_E000000581_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw4dcb4ed9/Y0000104/Y0000104_E000000581_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '004 Rose Gold Glow', color: '#DA768A', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw35ea8c1b/Y0000104/Y0000104_E000000582_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw03ab6099/Y0000104/Y0000104_E000000582_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '005 Sunlit Amber Glow', color: '#C47D68', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw4e972279/Y0000104/Y0000104_E000000583_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwc341a8ec/Y0000104/Y0000104_E000000583_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '007 Iced Honey Glow', color: '#E97C92', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3017811-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3017811-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: '006 Icy Rosy Glow', color: '#C884C2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3017803-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3017803-av-10-zoom.jpg?imwidth=1224'
        },

  ]},
  {id: 8, name: 'On ‘Til Dawn Mattifying Waterproof Setting Spray',
    category: 'Fijadores', formato: 'Spray',
    brand: 'One Size ',gama: 'Alta',
    price: 850, oldPrice: 790,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - 143 mL', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.onesizebeauty.com/cdn/shop/files/OTD_-_Key_Ingredients.jpg?v=1773867581&width=2048',
    shades:[]
  },
  {id: 9, name: 'Sheer For It Blush Tint',
    category: 'Lippies', formato: 'Tinta',
    brand: 'ELF',gama: 'media',
    price: 240, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/e6/66/19/e66619f10f9ced621ad9140663383e39.jpg',
    shades:[
        {
        name: 'Cherry Cola', color: '#6b1108', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_SheerForIt_Swatch_82324_CherryCola_20_1.jpg?v=1776967381&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0126_EDU_SheerForIt_OnSkintones_82324_cherrycola.jpg?v=1776967381&width=1440&height=1440&crop=center'
        },
        {
        name: 'Left On Red', color: '#c80000', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_SheerForIt_Swatch_82320_LeftonRed_20_1.jpg?v=1776967380&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0126_EDU_SheerForIt_OnSkintones_82320_leftonred.jpg?v=1776967380&width=1440&height=1440&crop=center'
        },
        {
        name: 'Maple Latte', color: '#965b45', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0526_SEO_SheerForIt_Swatch_83696_MapleLatte.jpg?v=1779996820&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/83696_OpenA_R_9b565ce2-da16-442d-a1c7-3fad048000a4.png?v=1778620728&width=1440&height=1440&crop=center'
        },
        {
        name: 'Plums Up', color: '#77001c', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_SheerForIt_Swatch_82323_PlumsUp_20_1.jpg?v=1776967381&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0126_EDU_SheerForIt_OnSkintones_82323_plumsup.jpg?v=1776967381&width=1440&height=1440&crop=center'
        },
        {
        name: 'So Petal', color: '#d14186', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0526_SEO_SheerForIt_Swatch_83698_SoPetal.jpg?v=1779996917&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/83698_OpenA_R_dbb49d20-034a-46ac-896f-f445a5c3d31e.png?v=1778620760&width=1440&height=1440&crop=center'
        },
        {
        name: 'Burgun-did That', color: '#94394a', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0526_SEO_SheerForIt_Swatch_83697_BurgunDidThat.jpg?v=1779996870&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/83697_OpenA_V2_R_db92af11-b9df-4f8f-bcb6-3ea1e0299fae.png?v=1778620744&width=1440&height=1440&crop=center'
        },
        {
        name: 'Pink Positive', color: '#d9163c', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_SheerForIt_Swatch_82322_PinkPositive_20_1.jpg?v=1776967378&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0126_EDU_SheerForIt_OnSkintones_82322_pinkpositive.jpg?v=1776967378&width=2880&height=2880&crop=center'
        },
        {
        name: 'Mauve Actually', color: '#9f2957', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0526_SEO_SheerForIt_Swatch_83695_MauveActually.jpg?v=1779996979&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/83695_OpenA_R_c3181282-d854-44e1-8172-1ead2b2d6b6f.png?v=1778620708&width=1440&height=1440&crop=center'
        },
        {
        name: 'Orange Crush', color: '#f05202', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_SheerForIt_Swatch_82321_OrangeCrush_20_1.jpg?v=1776967381&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0126_EDU_SheerForIt_OnSkintones_82321_orangecrush.jpg?v=1776967382&width=1440&height=1440&crop=center'
        },

  ]},
  {id: 10, name: 'Hydrating Camo Concealer',
    category: 'Correctores', formato: 'Liquido',
    brand: 'ELF ',gama: 'media',
    price: 250, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F34401d5a4f21469a9be21fb9dc95e6a4%2F6171884497e4479682e29d7c7b24830c?width=900&quality=85&format=webp',
    shades:[
        {
        name: 'Fair Rose', color: '#d5baa7', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84820_Open_A_R.png?v=1776967306&width=2880&height=2880&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Fair Warm', color: '#eec8a3', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84821_Open_A_R.png?v=1776967306&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Fair Beige', color: '#e4b6a6', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84822_Open_A_R.png?v=1776967306&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Light Ivory', color: '#e2b7a6', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84823_Open_A_R.png?v=1776967304&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_HydratingCamoConcelaer_LightIvory_84823_Swatch.jpg?v=1776967304&width=1440&height=1440&crop=center'
        },
        {
        name: 'Light Sand', color: '#f4c09b', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84824_Open_A_R.png?v=1776967312&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Light Peach', color: '#c8a891', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84825_Open_A_R.png?v=1776967307&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Light Beige', color: '#c19473', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84826_Open_A_R.png?v=1776967310&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Medium Peach', color: '#d8a178', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84827_Open_A_R.png?v=1776967318&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Medium Sand', color: '#c49464', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84828_Open_A_R.png?v=1776967316&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Medium Beige', color: '#c78b67', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84829_Open_A_R.png?v=1776967316&width=1440&height=1440&crop=center',
        swatchImage: 'https://www.superdrug.com/medias/sys_master/prd-images/hd9/h96/10667839062046/prd-ls1-772883_600x600/prd-ls1-772883-600x600.jpg'
        },
        {
        name: 'Medium Neutral', color: '#c49c83', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84830_Open_A_R.png?v=1776967310&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_HydratingCamoConcelaer_MediumNeutral_84830_Swatch.jpg?v=1776967309&width=2880&height=2880&crop=center'
        },
        {
        name: 'Medium Warm', color: '#c49c83', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/84831_Open_A_R.png?v=1776967312&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_HydratingCamoConcelaer_MediumWarm_84831_Swatch.jpg?v=1776967311&width=1440&height=1440&crop=center'
        },
  ]},
  {id: 11, name: '3d hydra lipgloss',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Kiko Milano ',gama: 'Media Alta',
    price: 500, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730013B%2F17-20260508.webp&q=80&w=1920&av=v1',
    shades:[
        {
        name: '01 Clear', color: '#ffff', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800144%2F01-20250828.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800144%2F04-20250828.webp&q=80&w=1920&av=v1'
        },
        {
        name: '05 Pearly Pink', color: '#F596B3', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800544%2F01-20250828.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800544%2F04-20250828.webp&q=80&w=1920&av=v1'
        },
        {
        name: '09 Soft Coral', color: '#FF7067', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800944%2F01-20250828.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM0020201800944%2F04-20250828.webp&q=80&w=1920&av=v1'
        },
        {
        name: '10 Sparkling Strawberry', color: '#E93470', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730010B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730010B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '11 Golden Red', color: '#EC3C58', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730011B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730011B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '12 Pearly Amaryllis Red', color: '#D81123', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730012B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730012B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '13 Fire Red', color: '#D20F25', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730013B%2F01-20260225.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730013B%2F04-20260225.webp&q=80&w=1920&av=v1'
        },
        {
        name: '15 Cherry Red', color: '#C20528', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730015B%2F01-20251022.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730015B%2F04-20251022.webp&q=80&w=1920&av=v1'
        },
        {
        name: '16 Iridescent Ruby', color: '#A11A28', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730016B%2F01-20260113.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730016B%2F04-20260113.webp&q=80&w=1920&av=v1'
        },
        {
        name: '17 Pearly Mauve', color: '#C7545D', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730017B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730017B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '21 Burn Rose', color: '#8A3C32', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730021B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730021B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '22 Sparkling Red Garnet', color: '#BC4B55', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730022B%2F01-20251022.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730022B%2F04-20251022.webp&q=80&w=1920&av=v1'
        },
        {
        name: '26 Sparkling Hibiscus Pink', color: '#DB667F', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730026B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730026B%2F04-20251201.jpg&q=80&w=1920&av=v1'
        },
        {
        name: '33 Pearly Watermelon', color: '#D25578', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730033B%2F01-20251022.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730033B%2F04-20251022.webp&q=80&w=1920&av=v1'
        },
        {
        name: '34 Pearly Blood Orange', color: '#DC4E28', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730034B%2F01-20251201.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730034B%2F04-20251201.webp&q=80&w=1920&av=v1'
        },
        {
        name: '35 Pearly Warm Mauve', color: '#D27474', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730035B%2F01-20251022.webp&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fimages.kikocosmetics.com%2Fcatalog%2FKM000000730035B%2F04-20251022.webp&q=80&w=1920&av=v1'
        },
        {
        name: '50 Sparkling Mauve - Ed.Lim', color: '#C64257', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2Fa6f313f4-78b8-2da9-03ba-8e8d667d0395&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2F7b8d96b0-b349-21ca-a4f5-8e93ed7a044c&q=80&w=1920&av=v1'
        },
        {
        name: '51 Frozen Light Blue - Ed.Lim', color: '#71b3d2', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2Fbae017bd-cf7c-3356-0924-8eaf5046068b&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2F3805d622-da73-15b3-64d4-8eb51caf0775&q=80&w=1920&av=v1'
        },
        {
        name: '44 Disruptive Brown', color: '#71362E', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2F3744c1e8-6b8a-674a-38e5-8e1384f80adb&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2Fd3f1c66a-95d1-1b44-3adb-8e125fd30949&q=80&w=1920&av=v1'
        },
        {
        name: '46 Marvellous Mauve', color: '#C22928', stock: true,
        image: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2F5a899378-c873-a2eb-37de-8e2d17320fcb&q=80&w=1920&av=v1',
        swatchImage: 'https://www.kikocosmetics.com/_next/image/?url=https%3A%2F%2Fassets.joqhl8w6.on-eva.io%2Fblob%2F4b796d52-118f-b2ab-dbf2-8e2e4b931033&q=80&w=1920&av=v1'
        },
  ]},
  {id: 12, name: 'Lip Maximizer',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Dior',gama: 'Lujo',
    price: 990, oldPrice: 950,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/c1/23/49/c12349fab4b70b2e4e9439224a129734.jpg',
    shades:[
        {
        name: '001 Pink', color: '#E696AD', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2635654-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635654-av-7-zoom.jpg?imwidth=1224'
        },
        {
        name: '007 Raspberry', color: '#F24C92', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2635704-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635704-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '040 Intense Blueberry', color: '#A90433', stock: true,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwe6293a4e/Y0319000/Y0319000_C031900040_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://cl-dam-resizer.ecomm.cencosud.com/unsafe/adaptive-fit-in/3840x0/filters:quality(75)/cl/paris/288001999/variant/69c594d804dde2a12e976a14/images/3519ee37-2c88-4d91-8406-0d892143ff47/288001999-0000-003.jpg'
        },
        {
        name: '009 Intense Rosewood', color: '#D0536A', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2635720-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635720-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: '038 Rose Nude', color: '#D96A73', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2635738-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635738-av-8-zoom.jpg?imwidth=1224'
        },
        {
        name: '020 Mahogany', color: '#6F0818', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2635787-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635787-av-7-zoom.jpg?imwidth=1224'
        },
        {
        name: '030 Shimmer Rose', color: '#E76B81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2635837-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635837-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '015 Cherry', color: '#D22724', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2657252-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2657252-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: '003 Holographic Lavender ', color: '#E5729B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2635670-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635670-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '012 Rosewood', color: '#DE8985', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2635746-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635746-av-7-zoom.jpg?imwidth=1224'
        },
        {
        name: '005 Shimmer Strawberry ', color: '#FA5874', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwb8783f8a/Y0319000/Y0319000_C031900005_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMf_6FWS_jGkeLHxnfv4jrvJyOsAKbAi-nbtwdQdKfmsABovkc9SgUElo&s=10'
        },
        {
        name: '026 Intense Mauve', color: '#D95B78', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2635803-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2635803-av-8-zoom.jpg?imwidth=1224'
        },
        {
        name: '014 Shimmer Macadamia', color: '#CD708A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2657260-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2657260-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: '010 Holographic Pink', color: '#FA6A92', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2657278-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2657278-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: '028 Dior 8 Intense', color: '#C12C23', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw14cfddbe/Y0319000/Y0319000_C031900028_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://http2.mlstatic.com/D_NQ_NP_820455-MLA110512780645_042026-O.webp'
        },
        {
        name: '023 Shimmer Fuchsia', color: '#EE4970', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw28a14a15/Y0319000/Y0319000_C031900023_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw1c382855/Y0319000/Y0319000_C031900023_E05_RHC.jpg?sw=942&sh=1412'
        },
  ]},
  {id: 13, name: 'Soulmates Face Palette',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Charlotte Tilbury ',gama: 'Alta',
    price: 1500, oldPrice: 1300,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 2 x 0,13 gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/2a/4f/9c/2a4f9cddd8f7e53ba1b919afa32926cb.jpg',
    shades:[
        {
        name: 'Rosewood', color: '#E06C6C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952745-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952745-av-1202601281050145250800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pink', color: '#F58DA3', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2871408-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2871408-av-1202601281057402150800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 14, name: 'Joystick Blush Stick',
    category: 'Rubores', formato: 'Crema',
    brand: 'Marc Jacobs',gama: 'Lujo',
    price: 1020, oldPrice: 895,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/4e/50/3a/4e503a394035e050a9289585f974b23b.jpg',
    shades:[
        {
        name: '111 Self Centered', color: '#C86A72', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994564-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994564-av-1202604241528561670700-zoom.jpg?imwidth=1224'
        },
        {
        name: '410 Freaks & Cheeks', color: '#8E1C3E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994812-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994812-av-1202604241529088360700-zoom.jpg?imwidth=1224'
        },
        {
        name: '113 Twin Cheeks', color: '#C02C4B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994648-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994648-av-1202604241528556910700-zoom.jpg?imwidth=1224'
        },
        {
        name: '310 Cherry Tease', color: '#8D1328', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994366-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994366-av-1202604241528524700700-zoom.jpg?imwidth=1224'
        },
        {
        name: '110 Hot Flush', color: '#FC7FB2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994317-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994317-av-1202604241527270050700-zoom.jpg?imwidth=1224'
        },
        {
        name: '112 Shady Business', color: '#CD5259', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994713-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994713-av-1202604241528501210700-zoom.jpg?imwidth=1224'
        },
        {
        name: '511 Pink Kink', color: '#FC2B6B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994432-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994432-av-1202604241528538160700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Papa Don´t Peach', color: '#FE744C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994358-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994358-av-1202604241528514660700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 15, name: 'Lip Oil Glimmer',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'ELF',gama: 'Media',
    price: 270, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true, 
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Fam_COMP_FULL_438_w4QC_RGB_IGF.jpg?v=1776967236&width=1440&height=1440&crop=center',
    shades:[
        {
        name: 'Divine Wine', color: '#903848', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0175_PLATE_FINAL_RGB_IGF.jpg?v=1776967243&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83051_DivineWine.jpg?v=1776967244&width=1440&height=1440&crop=center'
        },
        {
        name: 'Princess Cut', color: '#c84e4d', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0104_PLATE_FINAL_RGB_IGF.jpg?v=1776967244&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83050_PrincessCut.jpg?v=1776967244&width=1440&height=1440&crop=center'
        },
        {
        name: 'Chocoluxe', color: '#78412c', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0162_PLATE_FINAL_RGB_IGF.jpg?v=1776967235&width=1440&height=1440&crop=center',
        swatchImage: 'https://m.media-amazon.com/images/I/91JijiiSAaL._AC_SL1500_.jpg'
        },
        {
        name: 'Super-Neutral', color: '#c7472e', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0152_PLATE_FINAL_RGB_IGF.jpg?v=1776967236&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83049_SuperNeutral.jpg?v=1776967236&width=1440&height=1440&crop=center'
        },
        {
        name: 'Candy Coded', color: '#ffa7a6', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0104_PLATE_FINAL_RGB_IGF_c558145e-56b9-4543-9b76-7b9233d195a5.jpg?v=1776967304&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83048_CandyCoated_95819754-9309-4c59-bcd4-bc8cdb8e2e7f.jpg?v=1776967304&width=1440&height=1440&crop=center'
        },
        {
        name: 'Opal-ogy Tour', color: '#ffff', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0081_PLATE_FINAL_RGB_IGF.jpg?v=1776967245&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83047_Opal_Ology_Tour.jpg?v=1776967245&width=1440&height=1440&crop=center'
        },
        {
        name: 'Crystal Baller', color: '#cba389', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0063_PLATE_FINAL_RGB_IGF.jpg?v=1776967243&width=2880&height=2880&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83046_CrystalBaller.jpg?v=1776967243&width=1440&height=1440&crop=center'
        },
        {
        name: 'Citrine Gleam', color: '#e6b477', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/051324_GlowRev_Glimmer-Wands_0039_PLATE_FINAL_RGB_IGF.jpg?v=1776967241&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRLO_Glimmer_ShadeSpotlight_83045_CitrineGleam.jpg?v=1776967241&width=1440&height=1440&crop=center'
        },
  ]},
  {id: 16, name: 'Essential drip glossy balm',
    category: 'Lippies', formato: 'Balsamo',
    brand: 'Rem Beauty',gama: 'Alta', ss:false,
    price: 650, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/19/16/08/191608a7fb8dc8321fc89f466477ad84.jpg',
    shades:[
        {
        name: 'Cherry Cola', color: '#951D2A', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_6d6c07d1-0723-4c55-a57b-d9c377ad73fc.png?v=1762197963&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_50502a0e-d75c-4f74-bfaa-05b642e2c163.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Strawberry Soda', color: '#DA3478', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_cc3bf9fd-fae0-4d52-a0c2-f0c2daf7ee71.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_ae7cbb32-1496-4c31-a120-0c6d71398a5f.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Shirley', color: '#E82240', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_e7047f18-30e5-4d1c-b01c-291cd8eb0149.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_d15dc3f5-464a-4558-99a1-dc6a352676a6.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Hocus Cocoa', color: '#A24939', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_96c08b38-07c3-4348-b2ba-6a8cf17768c5.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_6c22b082-c1df-43a5-b862-13639d390b8f.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Cotton Candy', color: '#6F92AD', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_9_a9667edc-07f4-4249-aa63-15605fff9c03.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_cfb2eaaf-cb8b-497f-8ead-4324202dbd2e.png?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Fembot', color: '#B17471', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_lip-gloss-essential-drip-glossy-lip-balm-shimmer-rem-fembot.png?v=1750774065&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/06_lip-gloss-essential-drip-glossy-lip-balm-shimmer-rem-fembot-macros_d292d263-cff2-487b-98b6-100b6edc1f69.png?v=1775165480&width=1330&height=1552&crop=center'
        },
        {
        name: 'On Ice', color: '#B0B0B0', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_29c2d106-94c3-44ae-ae44-557a42cf4655.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_9.png?v=1775750013&width=1330&height=1552&crop=center'
        },
        {
        name: 'Juice Box', color: '#931C67', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_3b3d17ea-ce0d-4096-a425-fc009f203d37.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_aef052c4-46d7-4894-89c2-82561908dd78.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Skinny Dripped', color: '#E979B1', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_6b45260e-0fc4-4d8c-acb7-29857faef881.png?v=1748987313&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_96d3fb24-50ea-4850-b6c3-d5f5ba0b7e84.jpg?v=1748987313&width=1330&height=1552&crop=center'
        },
        {
        name: 'Knew Better', color: '#630A23', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_b7612df3-1ed5-49d2-b070-a1de104d0190.png?v=1779215673&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/04_bbea3c31-6695-416e-9049-b83501ea7bc1.png?v=1779215888&width=1330&height=1552&crop=center'
        },
        {
        name: 'Forever Boy', color: '#D38C8E', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_e83c3edf-6a81-436a-8273-2148ac2bf5b5.png?v=1779215687&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/06_7b0c3383-17b0-451b-b4ce-bf1395f04199.png?v=1779384439&width=1330&height=1552&crop=center'
        },
  ]},
  {id: 17, name: 'Mini major Blush Duo',
    category: 'Rubores', formato: 'Polvo & Crema',
    brand: 'Patrick Ta',gama: 'Alta',
    price: 750, oldPrice: 640,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Mini 2 x 2.6gr ', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/7f/12/34/7f1234bb4a98226d641c1bc6d9008bb5.jpg',
    shades:[
        {
        name: 'She´s that girl', color: '#FC5A73', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2906113-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesThatGirl-av-03.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She Goes To The Gym', color: '#AA4D4C', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2926020-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Goes_To_The_Gym_2.jpg?v=1754426761&width=1800'
        },
        {
        name: 'She Left Me On Red', color: '#D6001C', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2926004-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Left_Me_On_Red_1.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She Knows Who She Is', color: '#6B2B29', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3002003-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://patrickta.com/cdn/shop/files/P_Page_Imagery_-_Different_Skin_Tones_Model_-_She_Knows_Who_She_Is_1.jpg?v=1754074474&width=1200'
        },
        {
        name: 'She´s Blushing', color: '#CF6252', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3001997-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://patrickta.com/cdn/shop/files/BlushDuoU-PDP-ShesBlushing-av-03.jpg?v=1754074474&width=1200'
        },
  ]},
  {id: 18, name: 'Soft Pinch Tinted Lip Oil',
    category: 'Lippies', formato: 'Tinta/Oil',
    brand: 'Rare Beauty ',gama: 'Media Alta',
    price: 680, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 3ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/7a/c0/9c/7ac09ce4add1b3f45acb5904606a9b00.jpg',
    shades:[
        {
        name: 'Serenity', color: '#BC4D44', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-serenity-1440x1952_1440x.jpg?v=1762284990&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-serenity-1440x1952_1440x.jpg?v=1679094650&format=pjpg'
        },
        {
        name: 'Happy', color: '#DF6876', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-happy-1440x1952_1440x.jpg?v=1679094375&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-happy-1440x1952_1440x.jpg?v=1679094695&format=pjpg'
        },
        {
        name: 'Honesty', color: '#AF5E48', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-honesty-1440x1952_1440x.jpg?v=1679094472&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-honesty-1440x1952_1440x.jpg?v=1679337840&format=pjpg'
        },
        {
        name: 'Affection', color: '#7A2F4A', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-affection-1440x1952_1440x.jpg?v=1679094351&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-affection-1440x1952_1440x.jpg?v=1679094667&format=pjpg'
        },
        {
        name: 'Delight', color: '#9C4742', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-delight-1440x1952_1440x.jpg?v=1679094409&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-delight-1440x1952_1440x.jpg?v=1679337840&format=pjpg'
        },
        {
        name: 'Wonder', color: '#C46C7C', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-wonder-1440x1952_1440x.jpg?v=1679094452&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-wonder-1440x1952_1440x.jpg?v=1679337840&format=pjpg'
        },
        {
        name: 'Hope', color: '#DF828B', stock: true,
        image: 'https://www.rarebeauty.com/cdn/shop/products/soft-pinch-tinted-lip-oil-hope-1440x1952_1440x.jpg?v=1679094432&format=pjpg',
        swatchImage: 'https://www.rarebeauty.com/cdn/shop/products/soft-pinch-tinted-lip-oil-macro-lip-hope-1440x1952_1440x.jpg?v=1679337840&format=pjpg'
        },
        {
        name: 'Joy', color: '#CD5F55', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-joy-1440x1952_1440x.jpg?v=1679094393&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/products/soft-pinch-tinted-lip-oil-macro-lip-joy-1440x1952_1440x.jpg?v=1679337840&format=pjpg'
        },
  ]},
  {id: 19, name: 'Soft Pinch Lip Oil Stick',
    category: 'Lippies', formato: 'Oil',
    brand: 'Rare Beauty',gama: 'Media Alta',
    price: 680, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.4gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/09/ac/a5/09aca5a014b11b2e2214a4522bb2c1bd.jpg',
    shades:[
        {
        name: 'Muse', color: '#974143', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-MUSE_1440x.jpg?v=1782797895&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-MUSE_1440x.jpg?v=1782797919&format=pjpg'
        },
        {
        name: 'Dream', color: '#B7424A', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-DREAM_1440x.jpg?v=1782797733&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3000213-av-2-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Embrace', color: '#924F3E', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-EMBRACE_1440x.jpg?v=1782798023&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-EMBRACE_1440x.jpg?v=1782798054&format=pjpg'
        },
        {
        name: 'Fortune', color: '#8C183B', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-FORTUNE_1440x.jpg?v=1782798486&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-FORTUNE_1440x.jpg?v=1782798504&format=pjpg'
        },
        {
        name: 'Wish', color: '#FF5D62', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-WISH_1440x.jpg?v=1782797532&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-WISH_1440x.jpg?v=1782797601&format=pjpg'
        },
        {
        name: 'Journey', color: '#4A2723', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-JOURNEY_1440x.jpg?v=1782798609&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-JOURNEY_1440x.jpg?v=1782798628&format=pjpg'
        },
        {
        name: 'Bloom', color: '#EE418E', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-BLOOM_1440x.jpg?v=1782798300&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-BLOOM_1440x.jpg?v=1782798322&format=pjpg'
        },
        {
        name: 'Success', color: '#FF191C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-LIP-OIL-STICK-CAP-OFF-SUCCESS_1440x.jpg?v=1782798179&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-LIP-OIL-STICK-SUCCESS_1440x.jpg?v=1782798204&format=pjpg'
        },
  ]},
  {id: 20, name: 'Lip Oil Stick',
    category: 'Lippies', formato: 'Stick',
    brand: 'ELF ',gama: 'Media',
    price: 290, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true, ss:false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F34401d5a4f21469a9be21fb9dc95e6a4%2F4c43db76db9d43fc97e18e5d8ae41a27?width=900&quality=85&format=webp ',
    shades:[
        {
        name: 'Vine & Shine', color: '#B13D5F', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Vine_Shine_1.avif?v=1779288172&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_VineAndShine_bb1d8daf-53e1-4658-ac51-cfcc17adc8d6.jpg?v=1780398702&width=1440&height=1440&crop=center'
        },
        {
        name: 'Trufflemaker', color: '#873A35', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Trufflemaker.avif?v=1779288112&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_Trufflemaker.jpg?v=1780398574&width=1440&height=1440&crop=center'
        },
        {
        name: 'Cherry On Top', color: '#BD3744', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Cherry_on_the_top_1.avif?v=1779270499&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_CherryOnTop.jpg?v=1780396166&width=1440&height=1440&crop=center'
        },
        {
        name: 'Loveslick', color: '#C3677B', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Loveslick_1.avif?v=1779287807&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_Loveslick.jpg?v=1780396517&width=1440&height=1440&crop=center'
        },
        {
        name: 'Cara-melt', color: '#AE6C52', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Cara_Melt_q.avif?v=1779270349&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_Cara-Melt.jpg?v=1780396058&width=1440&height=1440&crop=center'
        },
        {
        name: 'Jam Packed', color: '#811824', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Jam_Packed_1.avif?v=1779287742&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_JamPacked.jpg?v=1780396457&width=1440&height=1440&crop=center'
        },
        {
        name: 'Rose Latte', color: '#A55E60', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Rose_Latte.avif?v=1779287987&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_RoseLatte.jpg?v=1780398320&width=1440&height=1440&crop=center'
        },
        {
        name: 'Mauve Mentality', color: '#884446', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Mauve_Mentality.avif?v=1779287870&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_MauveMentality.jpg?v=1780396586&width=1440&height=1440&crop=center'
        },
        {
        name: 'Pink-me Energy', color: '#DB8486', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Pink-Me_Energy_1.avif?v=1779287928&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_Pink-MeEnergy.jpg?v=1780398260&width=1440&height=1440&crop=center'
        },
        {
        name: 'Tanger-sheen', color: '#D35421', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Tanger-sheen_1.avif?v=1779288048&width=1440&height=1440&crop=center',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0661/2251/4520/files/0226_EDU_GRSS_ShadeSpotlight_Tanger-sheen.jpg?v=1780398423&width=1440&height=1440&crop=center'
        },
  ]},
  {id: 21, name: 'Hypernova satin matte blush',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Rem Beauty',gama: 'Media Alta',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/6c/80/9f/6c809f46f6dc16f2a97a68eb763bec22.jpg',
    shades:[
        {
        name: 'Pinking of u', color: '#E89DBB', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_45.png?v=1762197954&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_26.jpg?v=1740783834&width=1330&height=1552&crop=center'
        },
        {
        name: 'Rose on Mars', color: '#C88680', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_46.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/04_-_skinny_dipped_rose_on_mars.jpg?v=1740785434&width=1330&height=1552&crop=center'
        },
        {
        name: 'Stars in the sand', color: '#965446', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_48.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_29.jpg?v=1740785434&width=1330&height=1552&crop=center'
        },
        {
        name: 'Skinny Dipped', color: '#E78B8E', stock: true,
        image: 'https://rembeauty.com/cdn/shop/files/01_47.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_33.jpg?v=1740785434&width=1330&height=1552&crop=center'
        },
        {
        name: 'Strawberry Nebula', color: '#E03065', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_49.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/04_-_pinking_of_u_strawberry_nebula_1.jpg?v=1740785434&width=1330&height=1552&crop=center'
        },
        {
        name: 'Peach Planet', color: '#F19E8E', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_44.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_25.jpg?v=1740783834&width=1330&height=1552&crop=center'
        },
        {
        name: 'Jupiter Moon', color: '#985544', stock: false,
        image: 'https://rembeauty.com/cdn/shop/files/01_43.png?v=1740783834&width=1330&height=1552&crop=center',
        swatchImage: 'https://rembeauty.com/cdn/shop/files/03_24.jpg?v=1740783834&width=1330&height=1552&crop=center'
        },
  ]},
  {id: 22, name: 'Gloss Bomb',
    category: 'Lippies', formato: 'Fenty',
    brand: 'Fenty Beauty',gama: 'Media Alta',
    price: 595, oldPrice: 570,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 9 ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/1d/b2/dc/1db2dc43ac0bde9e5e2a3e211b9f8792.jpg',
    shades:[
        {
        name: 'Fuchsia Flex', color: '#A0144D', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2749133-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2749133-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Riri', color: '#B24D5A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2662468-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2662468-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Hot Chocolit', color: '#6D453E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2327245-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2327245-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Fu$$y', color: '#CF888F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2156578-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2156578-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Fenty Glow', color: '#DD9F8A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s1925965-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s1925965-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rose Amber', color: '#9F7779', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2907061-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2907061-av-1202507241536014890700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Wattabrat', color: '#DA6B95', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3007762-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3007762-av-1202605010845314240700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 23, name: 'Color Fuse Glassy Lip + Cheek Blush Balm Stick',
    category: 'Rubores', formato: 'Crema',
    brand: 'Haus Labs ',gama: 'Alta',
    price: 1050, oldPrice: 890,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 5gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/8c/15/bf/8c15bfdccb1006802d585e4c1ed6cd77.jpg',
    shades:[
        {
        name: 'Glassy Cayenn', color: '#A62933', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2870178-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2870178-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Rosette', color: '#C5536D', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2767549-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767549-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Cinnamon', color: '#8A3016', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2870194-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2870194-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Pitaya', color: '#F63C92', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767564-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767564-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Clove', color: '#541C2B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2870186-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2870186-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Watermelon', color: '#CF112C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767580-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767580-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Ginger', color: '#B17368', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2870202-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2870202-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Glassy Acai', color: '#7C214B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767598-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767598-av-1-zoom-1.jpg?imwidth=630'
        },
  ]},
  {id: 24, name: 'Easy Bake Loose Powder',
    category: 'Fijadores', formato: 'Polvo Suelto',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 980, oldPrice: 870, ss:true,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 20 gr', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/b5/9a/c2/b59ac248dd72900906f1ac75bb65eefb.jpg',
    shades:[
        {
        name: 'Sugar Cookie', color: '#AFB0B3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2114056-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114056-av-2202506021849308910700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cherry Blossom', color: '#e8adac', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2555811-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2555811-av-2202506021850547450700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pound Cake', color: '#dbb895', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2114072-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114072-av-2202506021850064230700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cupcake', color: '#e0a480', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2114064-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114064-av-2202506021849420630700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Peach Pie', color: '#e6ad81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739415-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739415-av-2202506021851035240700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Banana Bread', color: '#e6be81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2114080-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114080-av-2202506021850185130700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Matcha', color: '#91bf69', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2947976-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2947976-av-2202601260840239560800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Blondie', color: '#dba056', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2114098-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114098-av-2202506021850244040700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 25, name: 'BTW Concealer',
    category: 'Correctores', formato: 'Liquido',
    brand: 'Too Faced',gama: 'Media Alta',
    price: 970, oldPrice: 800,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 13.5 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/27/bb/80/27bb80237daf0896924a554b184592fe.jpg',
    shades:[
        {
        name: 'Snow', color: '#F7C3A2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084374-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084374-av-43-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cream Puff', color: '#F2B199', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2223006-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2223006-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Almond', color: '#E3A57F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084390-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084390-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Vanilla', color: '#E09D76', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084416-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084416-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Nude', color: '#D58E6D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084424-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084424-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Light Beige', color: '#BF7956', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084440-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084440-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Taffy', color: '#D88964', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2223048-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2223048-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Natural Beige', color: '#CD8350', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084457-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084457-av-0001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Warm Beige', color: '#BB7348', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084465-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084465-av-0001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sand', color: '#C4764D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2084473-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2084473-av-0001-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 26, name: 'Dior Backstage Rosy Glow Stick',
    category: 'Rubores', formato: 'Crema en barra',
    brand: 'Dior',gama: 'Lujo',
    price: 1100, oldPrice: 980,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/23/b1/b1/23b1b19d5bdbf2eea6a08e5e61e0522b.jpg ',
    shades:[
        {
        name: '001 Pink', color: '#f680bb', stock: false,
        image: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dwb15d244f/Y0000048/Y0000048_E000000453_E01_RHC.jpg?sw=1280',
        swatchImage: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dw7639b72d/Y0000048/Y0000048_E000000453_E03_RHC.jpg?sw=1280'
        },
        {
        name: '006 Berry', color: '#be4571', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dweb7247e8/Y0000048/Y0000048_E000000448_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw0ece779f/Y0000048/Y0000048_E000000448_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '012 Rosewood', color: '#d8738d', stock: true,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwafa1fa53/Y0000048/Y0000048_E000000452_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw39ab7e81/Y0000048/Y0000048_E000000452_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '015 Cherry', color: '#ef4a56', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwd717bf8a/Y0000048/Y0000048_E000000449_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw8e4f83e9/Y0000048/Y0000048_E000000449_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '077 Candy', color: '#dd606b', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw2bad1070/Y0000048/Y0000048_E000000446_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwcef2898d/Y0000048/Y0000048_E000000446_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '103 Toffee', color: '#d08978', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw0c30e039/Y0000048/Y0000048_E000000451_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwf1e2b329/Y0000048/Y0000048_E000000451_E03_RHC.jpg?sw=942&sh=1412'
        },
        {
        name: '106 Pomelo', color: '#f17877', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw1cd31737/Y0000048/Y0000048_E000001726_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962330-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '107 Dragonfruit', color: '#ee6987', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw8760cc63/Y0000048/Y0000048_E000001725_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962389-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '108 Guava', color: '#f53a4a', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw826bd8db/Y0000048/Y0000048_E000001724_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962587-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '109 Goji', color: '#952e2c', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwc2e319c0/Y0000048/Y0000048_E000001908_E01_RHC.jpg?sw=942&sh=1412',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962454-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 27, name: 'Lip Butter Balm',
    category: 'Lippies', formato: 'Balsamo',
    brand: 'Summer Fridays',gama: 'Media Alta',
    price: 750, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 15 gr', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'', ss:true,
    image: 'https://i.pinimg.com/736x/10/a2/d0/10a2d084d9622d65467e303d9245f975.jpg',
    shades:[
        {
        name: 'Cherry', color: '#B40030', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2652121-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2652121-av-15-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Brown Sugar', color: '#84514D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2590578-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2590578-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pink Guava', color: '#F04370', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2862480-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2862480-av-8202505221243270880700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sweet Mint', color: '#B7BE9C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2715035-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2715035-av-6-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Iced Coffee', color: '#A96D4F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2781565-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2781565-av-13-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry Soft Serve', color: '#EE6987', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2968907-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2968907-av-1202605281058449730700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Vanilla Beige', color: '#C38F7C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2495497-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2495497-av-17-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pink Sugar', color: '#DD636A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2652113-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2652113-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sugar Plum', color: '#B42F49', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994994-main-zoom-2.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994994-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 28, name: 'ShineOn Lip Oil Jelly',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'Tower 28 ',gama: 'Media Alta',
    price: 540, oldPrice: 480,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '3.9ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/dc/f3/e1/dcf3e1a5aed1f5e67f625e8ec470f72c.jpg ',
    shades:[
        {
        name: 'Almond', color: '#9E6558', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2375459-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2375459-av-18-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Coconut', color: '#CE4664', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2375434-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2375434-av-14-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cashew', color: '#A15957', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2375442-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2375442-av-17-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Wild', color: '#9E1E4E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2549988-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2549988-av-13-zoom.jpg?imwidth=1224'
        },
        {
        name: 'XOXO', color: '#D8011C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2284610-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2284610-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pistachio', color: '#D07C86', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2549970-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2549970-av-12-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sesame', color: '#B34A69', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2593812-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2593812-av-20-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 29, name: 'Legally Bronze',
    category: 'Bronzer', formato: 'Polvo',
    brand: 'Marc Jacobs',gama: 'Lujo',
    price: 1250, oldPrice: 1050, ss:true,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 11 gr', new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/c5/d9/02/c5d902c16f5e7c5a5da7cd6c24ccb437.jpg ',
    shades:[
        {
        name: '10 Fair', color: '#C98962', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994333-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994333-av-6202604241323321080700-zoom.jpg?imwidth=1224'
        },
        {
        name: '15 Light', color: '#C48059', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994382-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994382-av-6202604241323343320700-zoom.jpg?imwidth=1224'
        },
        {
        name: '20 Light Medium', color: '#A66641', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994820-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994820-av-6202604241323266320700-zoom.jpg?imwidth=1224'
        },
        {
        name: '30 Medium', color: '#A06346', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994556-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994556-av-6202604241323369840700-zoom.jpg?imwidth=1224'
        },
        {
        name: '30 Medium Plus', color: '#A1664A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994689-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994689-av-6202604241323420120700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 30, name: 'Blush Butter Balm',
    category: 'Rubores', formato: 'Crema',
    brand: 'Summer Fridays',gama: 'Alta', ss:true,
    price: 850, oldPrice: 740,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '2.4 gr', new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/50/16/4c/50164c9bf38958383682d5452f4bc52c.jpg',
    shades:[
        {
        name: 'Soft Strawberry', color: '#D66B6A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879328-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879328-av-1202506171439423100700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pink Sunset', color: '#FF6F82', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879310-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879310-av-1202506171357073560700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sweet Rosé', color: '#C85D6D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879286-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879286-av-1202506171438015860700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Dusty Rose', color: '#A44A4F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879336-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879336-av-1202506181616396960700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Toasted Terracotta', color: '#AB5E58', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879278-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879278-av-1202506171421539200700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Berry Spritz', color: '#6B2730', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879294-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879294-av-1202506181450073230700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 31, name: 'Make Me Blush Powder',
    category: 'Rubores', formato: 'Polvo',
    brand: 'YSL',gama: 'Lujo',
    price: 1200, oldPrice: 1080,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/71/d5/a3/71d5a3fec647a767649414c5e259620d.jpg',
    shades:[
        {
        name: '54 Berry Bang', color: '#B8505C', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2830214-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830214-av-4202605201240483760700-zoom.jpg?imwidth=1224'
        },
        {
        name: '44 Nude Lavalliere', color: '#B6636F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830206-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830206-av-1202605201240432040700-zoom.jpg?imwidth=1224'
        },
        {
        name: '87 Pink Voltage', color: '#EF829C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830248-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830248-av-3202605201240509770700-zoom.jpg?imwidth=1224'
        },
        {
        name: '12 Honeymoon', color: '#B25756', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935195-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935195-av-4202605201241011630700-zoom.jpg?imwidth=1224'
        },
        {
        name: '93 Restless Rose', color: '#F08BA7', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830255-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830255-av-3202605201247579910700-zoom.jpg?imwidth=1224'
        },
        {
        name: '66 Fuchsia Fizz', color: '#E0588B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2933356-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2933356-av-1202602201315344510800-zoom.jpg?imwidth=1224'
        },
        {
        name: '38 Velvet Latte', color: '#A25354', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2999456-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2999456-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '6 Rose Haze', color: '#E5A9A8', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830230-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830230-av-3202605201240455560700-zoom.jpg?imwidth=1224'
        },
        {
        name: '15 Chili Crush', color: '#B42F2A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2884930-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2884930-av-3202605201230042590700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 32, name: 'Make Me Blush Cream Blush',
    category: 'Rubores', formato: 'Crema',
    brand: 'YSL',gama: 'Lujo',
    price: 1200, oldPrice: 1080,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 4.5gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2996577-av-10-zoom-1.jpg?imwidth=1224 ',
    shades:[
        {
        name: '23 Hot Mauve', color: '#A46359', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996577-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996577-av-3-zoom-1.jpg?imwidth=1224'
        },
        {
        name: '44 Nude Lavalliere', color: '#CB5F6F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996619-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996619-av-1-zoom-2.jpg?imwidth=1224'
        },
        {
        name: '37 Peachy Nude', color: '#C8523E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996593-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996593-av-1-zoom-2.jpg?imwidth=1224'
        },
        {
        name: '65 Strawberry Seduction', color: '#9F1E22', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996585-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996585-av-1-zoom-1.jpg?imwidth=1224'
        },
        {
        name: '90 Toffee Temptation', color: '#AA5440', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996601-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996601-av-2-zoom-2.jpg?imwidth=1224'
        },
        {
        name: '86 Raspberry Glaze', color: '#992437', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2996569-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2996569-av-1-zoom-2.jpg?imwidth=1224'
        },
        
  ]},
  /*{id: 33, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 34, name: 'Luminous Powder Blush',
    category: 'Rubores', formato: 'Polvo Luminoso',
    brand: 'Rare Beauty ',gama: 'Media Alta',
    price: 770, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '25gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2748333-av-8-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Cheer', color: '#E68F86', stock: false,
        image: 'https://www.rarebeauty.com/cdn/shop/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-CHEER_1440x.jpg?v=1762292447&format=pjpg',
        swatchImage: 'https://www.rarebeauty.com/cdn/shop/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-CHEER_1440x.jpg?v=1711393177&format=pjpg'
        },
        {
        name: 'Happy', color: '#EE6987', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-HAPPY_1440x.jpg?v=1711393177&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-HAPPY_1440x.jpg?v=1711393161&format=pjpg'
        },
        {
        name: 'Hope', color: '#E08E7C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-HOPE_1440x.jpg?v=1711393177&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-HOPE_1440x.jpg?v=1711393177&format=pjpg'
        },
        {
        name: 'Truth', color: '#B54F4D', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-TRUTH_1440x.jpg?v=1711393161&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-TRUTH_1440x.jpg?v=1711393161&format=pjpg'
        },
        {
        name: 'Love', color: '#CD5F55', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-LOVE_1440x.jpg?v=1711393161&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-LOVE_1440x.jpg?v=1711393161&format=pjpg'
        },
        {
        name: 'Joy', color: '#DB6C5C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-JOY_1440x.jpg?v=1711393161&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ON-FIGURE-SOFT-PINCH-LUMINOUS-POWDER-BLUSH-JOY_1440x.jpg?v=1711393161&format=pjpg'
        },
  ]},
  {id: 35, name: 'Gloss Bomb Stix',
    category: 'Lippies', formato: 'Gloss Stick',
    brand: 'Fenty Beauty ',gama: 'Media Alta',
    price: 740, oldPrice: 630,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.6 gr', new: false, stock: true,ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/87/54/f3/8754f3106eb8e17d0445fbc2e9d618c7.jpg',
    shades:[
        {
        name: 'Is it Fu$$y', color: '#BF6B70', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2787489-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2787489-av-8-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Riri', color: '#7B303E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2787497-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2787497-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sorta $Elfish', color: '#A05020', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2787539-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2787539-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: 'N-2 Fu$$Y ', color: '#E67782', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847747-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847747-av-04-zoom.jpg?imwidth=1224'
        },
        {
        name: 'N9 - Icy Amethy$t', color: '#C885C4', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847804-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847804-av-04-zoom.jpg?imwidth=1224'
        },
        {
        name: 'N5 - Hot Chocolit', color: '#582E28', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847788-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847788-av-04-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 36, name: 'Lip Gloss with Hyaluronic Acid',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Refy',gama: 'Alta',
    price: 520, oldPrice: 530,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 13 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/d7/18/c7/d718c7b8c02ace28dad588b64f781c30.jpg',
    shades:[
        {
        name: 'Clear', color: '', stock: false,
        image: ' https://www.sephora.com/productimages/sku/s2554772-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2554772-av-011-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Blush', color: '#E57461', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2722890-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2722890-av-011-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Dusk', color: '#D14D3A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743441-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743441-av-011-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rosewood', color: '#CF6959', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2722908-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2722908-av-58-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Suede', color: '#754B35', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2835635-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2835635-av-0111-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Taupe', color: '#DD7660', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743433-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743433-av-011-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Red', color: '#B4181D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2799245-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2799245-av-05-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Fawn', color: '#CC5E3D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2722916-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2722916-av-011-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Plum', color: '#6F1C49', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2920908-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2920908-av-1202509170220156640700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sepia', color: '#7A4136', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2722924-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2722924-av-011-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 37, name: 'Mini Easy Bake Loose Powder',
    category: 'Fijadores', formato: 'Polvo Suelto',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 660, oldPrice: 570,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini  - 6 gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/2e/4b/c2/2e4bc2ff1fbcf58cfdc07a9d8a952f07.jpg',
    shades:[
        {
        name: 'Sugar Cookie', color: '#AFB0B3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2881837-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114056-av-2202506021849308910700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cherry Blossom', color: '#e8adac', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2881860-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2555811-av-2202506021850547450700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pound Cake', color: '#dbb895', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2881886-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114072-av-2202506021850064230700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Peach Pie', color: '#e6ad81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2881845-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739415-av-2202506021851035240700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Banana Bread', color: '#e0bc82', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2881852-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114080-av-2202506021850185130700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 38, name: 'Triclone Hydrating Concealer',
    category: 'Correctores', formato: 'Crema',
    brand: 'Haus Labs ',gama: 'Alta',
    price: 980, oldPrice: 840,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 7 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/8c/f6/8f/8cf68f85fc9b4bd1bef035404833d76d.jpg',
    shades:[
        {
        name: '04 Fair Neutral', color: '#D8BAAB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696961-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696961-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '05 Fair Peach', color: '#D2AE94', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696953-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696953-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '10 Light Golden', color: '#DDB99A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696938-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696938-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '11 Light Neutral ', color: '#D6B597', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696920-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696920-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '13 Light Neutral', color: '#C3A38E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696904-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696904-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '21 Light Medium Neutral', color: '#D6B391', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696870-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696870-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '23 Light Medium Golden', color: '#BC937E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696854-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696854-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '24 Light Medium Neutral', color: '#C39880', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696847-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696847-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '30 Medium Peach', color: '#CE9775', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696839-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696839-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '32 Medium Golden', color: '#C7906A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696813-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696813-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '34 Medium Golden', color: '#B27F58', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2696797-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2696797-av-1-zoom-1.jpg?imwidth=630'
        },
  ]},
  {id: 39, name: 'Lip Glow Butter',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Dior',gama: 'Lujo',
    price: 1000, oldPrice: 950,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 10ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/a8/30/bf/a830bf4e90680bd5cb22efc5f0d37612.jpg',
    shades:[
        {
        name: '101 Glazed Pink', color: '#EB9AAD', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw69d99c47/Y0000050/Y0000050_E000000588_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw9f0eed31/Y0000050/Y0000050_E000000588_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '102 Glazed Lavender', color: '#C298CB', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw7d67c586/Y0000050/Y0000050_E000000589_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw1e1bf570/Y0000050/Y0000050_E000000589_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '103 Toffee', color: '#8F4739', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwb05f26e8/Y0000050/Y0000050_E000000590_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw9bf775d9/Y0000050/Y0000050_E000000590_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '104 Black Cherry', color: '#74333E', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwa767218b/Y0000050/Y0000050_E000000591_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw687f380a/Y0000050/Y0000050_E000000591_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '105 Lychee', color: '#E12253', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwdbc44aa4/Y0000050/Y0000050_E000000592_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw64c9432a/Y0000050/Y0000050_E000000592_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '106 Pomelo', color: '#DD716C', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw7717b026/Y0000050/Y0000050_E000001669_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962447-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '107 Dragonfruit', color: '#D3607A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2962629-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962629-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '108 Guava', color: '#E65168', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2962579-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962579-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '109 Goji', color: '#661F1F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2962520-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962520-av-2-zoom.jpg?imwidth=1224'
        },   
  ]},
  {id: 40, name: 'Backstage Airflash Mist Makeup Setting Spray',
    category: 'Fijadores', formato: 'Liquido',
    brand: 'Dior',gama: 'Lujo', 
    price: 1160, oldPrice: 1020,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '100 ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/f8/87/99/f88799ad717bffc04ce4e58b7ad4719a.jpg',
    shades:[
  ]},
  {id: 41, name: 'Dotcom Lip Balm',
    category: 'Lippies', formato: 'Bálsamo',
    brand: 'Glossier',gama: 'Media Alta',
    price: 500, oldPrice: 430,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '15ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/8e/0a/3b/8e0a3b4964530e233746e08e50d583ad.jpg ',
    shades:[
        {
        name: 'Just Baked', color: '#92454F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3026143-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3026143-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Toasty Nuts', color: '#EF972F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3026150-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3026150-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Black Cherry', color: '#941E20', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2839397-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2839397-av-1202505211500160850700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Espresso', color: '#502E1E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2868156-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2868156-av-1202505211506003870700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry', color: '#EC5178', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2771541-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2771541-av-1202505211522111450700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Mango', color: '#FD7C4F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2771608-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2771608-av-1202505211509186870700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Wild Fig', color: '#B20A09', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2771624-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2771624-av-1202505211525385060700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 42, name: 'Touch Soft Blush',
    category: 'Rubores', formato: 'Crema a Polvo',
    brand: 'Prada',gama: 'Lujo',
    price: 1300, oldPrice: 1130,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.5gr',new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/3e/5a/dc/3e5adcb517359c09b4012bf49b59aed7.jpg',
    shades:[
        {
        name: 'B32 Caffee', color: '#71362E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952778-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952778-av-1202603201535046260700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P72 Dahlia', color: '#D47170', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952737-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952737-av-1202603201532201920700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P75 Tulip', color: '#D65C73', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952729-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952729-av-1202603201530216300700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P79 Mauve', color: '#822F3D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952760-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952760-av-1202603201531156440700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P71 Bow', color: '#B75B53', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952711-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952711-av-1202603201534127380700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'R68 Cherry', color: '#C61B1C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952752-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952752-av-1202603201527585430700-zoom.jpg?imwidth=1224'
        },
        {
        name: '086 Peach', color: '#EA8788', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952794-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952794-av-1202603201529313720700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P76 Waterlily', color: '#D64668', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2952786-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2952786-av-1202603201533149310700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'P36 Wisteria Lilac', color: '#DDA1D5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2995850-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2995850-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 43, name: 'Peptide Lip Treatment',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Rhode',gama: 'Media Alta',
    price: 580, oldPrice: 500,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 10ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2895795-av-2202604271452502250700-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Strawberry Glaze', color: '#BD1321', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895894-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895894-av-3202508071734500870700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rhode Vanilla', color: '#EE6987', stock: true ,
        image: 'https://www.sephora.com/productimages/sku/s2895910-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895910-av-3202508071735026140700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Salted Caramel', color: '#C66822', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2896140-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896140-av-3202508071734557680700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Watermelon Slice', color: '#B14038', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2895795-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895795-av-3202508071734452210700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Unscented', color: '#787F7D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895811-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895811-av-3202508071734395530700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 44, name: 'Swipe All-Over Serum Concealer',
    category: 'Correctores', formato: 'Liquido',
    brand: 'Tower 28',gama: 'Media Alta',
    price: 740, oldPrice: 610,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6.5 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/c1/6a/94/c16a94d0ac8841723b714d8b40fadde9.jpg',
    shades:[
        {
        name: '2.0 BU', color: '#F2DECE', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697498-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697498-av-2202601190831133640800-zoom.jpg?imwidth=1224'
        },
        {
        name: '3.0 CC', color: '#FCD8BB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697506-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697506-av-2202601190831179550800-zoom.jpg?imwidth=1224'
        },
        {
        name: '4.0 DTLA ', color: '#F2DECE', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697514-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697514-av-2202601190831228890800-zoom.jpg?imwidth=1224'
        },
        {
        name: '5.5 HH', color: '#F2CBAE', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945152-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945152-av-2202512191408122870800-zoom.jpg?imwidth=1224'
        },
        {
        name: '6.0 IE', color: '#F1CCB2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697530-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697530-av-2202601190831317180800-zoom.jpg?imwidth=1224'
        },
        {
        name: ' 7.0 KTOWN', color: '#EBC1A6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697548-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697548-av-2202601190831382980800-zoom.jpg?imwidth=1224'
        },
        {
        name: '7.5 LAD', color: '#F8BCA9', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945137-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945137-av-2202512191412026540800-zoom.jpg?imwidth=1224'
        },
        {
        name: '8.0 LBC', color: '#F5C89F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697555-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697555-av-2202601190831412070800-zoom.jpg?imwidth=1224'
        },
        {
        name: '9.0 MDR', color: '#EBBC9A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697563-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697563-av-2202601190831467510800-zoom.jpg?imwidth=1224'
        },
        {
        name: '9.5 MV', color: '#E8B48B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945020-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945020-av-2202512191415052670800-zoom.jpg?imwidth=1224'
        },
        {
        name: '10.0 NOHO ', color: '#EAAA7D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697571-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697571-av-2202601190831507900800-zoom.jpg?imwidth=1224'
        },
        {
        name: '12.0 PALI', color: '#D5996B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2697597-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2697597-av-2202601190831593280800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 45, name: 'Positive Light Luminizing Lip Gloss',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Rare Beauty',gama: 'Media Alta',
    price: 600, oldPrice: 520,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.3 ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2876357-av-15202507161146506800700-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Glimmer', color: '#CA6C72', stock: true,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-GLIMMER_1440x.jpg?v=1751499827&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-GLIMMER_1440x.jpg?v=1755192734&format=pjpg'
        },
        {
        name: 'Spark', color: '#A05749', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-SPARK_1440x.jpg?v=1751499827&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-SPARK_1440x.jpg?v=1755192734&format=pjpg'
        },
        {
        name: 'Flicker', color: '#F56F85', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-FLICKER_1440x.jpg?v=1751499827&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-FLICKER_1440x.jpg?v=1755192734&format=pjpg'
        },
        {
        name: 'Blaze', color: '#845146', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-BLAZE_1440x.jpg?v=1751499827&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-BLAZE_1440x.jpg?v=1755192734&format=pjpg'
        },
        {
        name: 'Beam', color: '#FE8773', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-BEAM_1440x.jpg?v=1751499827&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-BEAM_1440x.jpg?v=1755192734&format=pjpg'
        },
        {
        name: 'Dazzle', color: '#BFBFBF', stock: false,
        image: 'https://www.rarebeauty.com/cdn/shop/files/ECOMM-POSITIVE-LIGHT-LUMINIZING-LIP-GLOSS-DAZZLE_1440x.jpg?v=1762303835&format=pjpg',
        swatchImage: 'https://www.rarebeauty.com/cdn/shop/files/SHADE-GRIDS-PL-LUMINIZING-LIP-GLOSS-DAZZLE_1440x.jpg?v=1755192734&format=pjpg'
        },
  ]},
  /*{id: 46, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 47, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 48, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',   new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 49, name: 'Matte Bouncy Blush',
    category: 'Rubores', formato: 'Crema a Polvo ',
    brand: 'Rare Beauty',gama: 'Media Alta',
    price: 770, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6.4 gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/8d/22/9a/8d229ac8bcdbc2d757c47e6778cc96ef.jpg',
    shades:[
        {
        name: 'Hope', color: '#D26D69', stock: false,
        image: 'https://www.rarebeauty.com/cdn/shop/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-HOPE_1440x.jpg?v=1762301246&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-HOPE_1440x.jpg?v=1738367184&format=pjpg'
        },
        {
        name: 'Happy', color: '#EE6E75', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-HAPPY_1440x.jpg?v=1742429182&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-HAPPY_1440x.jpg?v=1742429382&format=pjpg'
        },
        {
        name: 'Divine', color: '#BD5C68', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-DIVINE_1440x.jpg?v=1767911200&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-DIVINE_1440x.jpg?v=1768000456&format=pjpg'
        },
        {
        name: 'Grateful', color: '#F53A4A', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-GRATEFUL_1440x.jpg?v=1742429382&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-GRATEFUL_1440x.jpg?v=1742429382&format=pjpg'
        },
        {
        name: 'Worth', color: '#C26052', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-WORTH_1440x.jpg?v=1742429382&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-WORTH_1440x.jpg?v=1742429382&format=pjpg'
        },
        {
        name: 'Thriving', color: '#E05267', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-THRIVING_1440x.jpg?v=1742429382&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-THRIVING_1440x.jpg?v=1742429382&format=pjpg'
        },
        {
        name: 'Truth', color: '#9D5159', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-TRUTH_1440x.jpg?v=1742429382&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-TRUTH_1440x.jpg?v=1742429382&format=pjpg'
        },
        {
        name: 'Soulful', color: '#711A2D', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SP-MATTE-BOUNCY-BLUSH-SOULFUL_1440x.jpg?v=1768000456&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/SHADE-GRIDS-SP-MATTE-BOUNCY-BLUSH-SOULFUL_1440x.jpg?v=1768000456&format=pjpg'
        },
  ]},
  {id: 50, name: 'Lip Glow Oil',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'Dior',gama: 'Lujo',
    price: 990, oldPrice: 950,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Library-Sites-DiorSharedLibrary/default/dw17d100c2/images/beauty/02-MAKEUP/2026/ADDICT/PDP/M123_ADDICT_26_P12_GAMME_LIPGLOW_ALL_FINISHES_SW_F39.jpg?sw=1920',
    shades:[
        {
        name: '001 Pink - Juicy', color: '#FE7797', stock: false,
        image: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dw724a0506/Y0000163/Y0000163_E000001063_E01_RHC.jpg?sw=1280',
        swatchImage: 'https://www.dior.com/dw/image/v2/BGXS_PRD/on/demandware.static/-/Sites-master_dior/default/dw1405fba8/Y0000163/Y0000163_E000001063_E03_RHC.jpg?sw=1280'
        },
        {
        name: '015 Cherry - Juicy', color: '#F53A4A', stock: true,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw2b36d67d/Y0000163/Y0000163_E000001052_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwdb057225/Y0000163/Y0000163_E000001052_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '012 Rosewood - Juicy', color: '#E96C6B', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw5f56c1ac/Y0000163/Y0000163_E000001053_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw087b7ab1/Y0000163/Y0000163_E000001053_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '007 Raspberry - Juicy', color: '#FC599F', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw8951dc87/Y0000163/Y0000163_E000001516_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw30cb7125/Y0000163/Y0000163_E000001516_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '006 Berry - Juicy', color: '#86024C', stock: false ,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwd838b5a1/Y0000163/Y0000163_E000001054_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwe6a3a936/Y0000163/Y0000163_E000001054_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '031 Strawberry - Glaze', color: '#C8101B', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwc2949ffc/Y0000163/Y0000163_E000001059_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw9ab1edb3/Y0000163/Y0000163_E000001059_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '046 Cranberry - Juicy', color: '#971423', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwd8d045f9/Y0000163/Y0000163_E000001344_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw23588745/Y0000163/Y0000163_E000001344_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '081 Latte - Glaze', color: '#A44F4E', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwadad4082/Y0000163/Y0000163_E000001057_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwe5391fa7/Y0000163/Y0000163_E000001057_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '074 Jelly - Glaze', color: '#FA3E60', stock: true,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw3976bbbe/Y0000163/Y0000163_E000001062_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwd51dabc5/Y0000163/Y0000163_E000001062_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '088 Mocha - Sparkly', color: '#A74D4B', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwa8d77036/Y0000163/Y0000163_E000001515_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwc9f7b961/Y0000163/Y0000163_E000001515_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '104 Black Cherry - Glaze', color: '#791B2B', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwc7b538fc/Y0000163/Y0000163_E000001056_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw999ecf51/Y0000163/Y0000163_E000001056_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '085 Cupcake - Sparkly', color: '#ffffff', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwd45d374e/Y0000163/Y0000163_E000001061_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw28c42372/Y0000163/Y0000163_E000001061_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '087 Spicy - Sparkly', color: '#F18479', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw0b468273/Y0000163/Y0000163_E000001055_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwa298b160/Y0000163/Y0000163_E000001055_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '086 Minty - Sparkly', color: '#93CCB1', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dwfc162087/Y0000163/Y0000163_E000001058_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw1761bebf/Y0000163/Y0000163_E000001058_E03_selectorPanelDesktop.jpg'
        },
        {
        name: '041 Peachy - Juicy', color: '#FE5D36', stock: false,
        image: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw2af37555/Y0000163/Y0000163_E000001345_E01_selectorPanelDesktop.jpg',
        swatchImage: 'https://www.dior.com/on/demandware.static/-/Sites-master_dior/default/dw1b7f2ac2/Y0000163/Y0000163_E000001345_E03_selectorPanelDesktop.jpg'
        },
  ]},
  {id: 51, name: 'BeachPlease Blush',
    category: 'Rubores', formato: 'Crema',
    brand: 'Tower 28',gama: 'Media Alta',
    price: 640, oldPrice: 520,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '0.158 gr', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'', ss:true,
    image: 'https://i.pinimg.com/736x/69/0f/52/690f52189cffff3c3c347c8c579ca8ae.jpg',
    shades:[
        {
        name: 'Magic Hour', color: '#E08483', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20Magic_20Hour_90ccf943-90c1-4d08-b927-64bf2dae2b60.webp?v=1745444273&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-MH-Quad-PDP.jpg?v=1753295514&width=1800'
        },
        {
        name: 'Finest Hour', color: '#CE122C', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/FINEST_HOUR-PDP_1.webp?v=1762197923&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/FINESTHOUR-PDP_1.png?v=1753295647&width=1800'
        },
        {
        name: 'Power Hour', color: '#C35E60', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20Power_20Hour.webp?v=1753295647&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-PH-Quad-PDP.jpg?v=1753295647&width=1800'
        },
        {
        name: 'After Hours ', color: '#BC3555', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20After_20Hours_1.webp?v=1753295647&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-AH-Quad-PDP.jpg?v=1753295647&width=1800'
        },
        {
        name: 'Dream Hour', color: '#FF85B8', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20Dream_20Hour.webp?v=1753295514&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-DH-Quad-PDP.jpg?v=1753295514&width=1800'
        },
        {
        name: 'Office Hours', color: '#B7697C', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20Office_20Hours.webp?v=1753295647&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-OH-Quad-PDP.jpg?v=1753295647&width=1800'
        },
        {
        name: 'Happy Hour', color: '#F05F71', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/BeachPlease_20Happy_20Hour.webp?v=1753295647&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/BP-HH-Quad-PDP.jpg?v=1753295829&width=1800'
        },
  ]},
  {id: 52, name: 'Easy Bake Pressed Powder',
    category: 'Fijadores', formato: 'Polvo Compacto',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 990, oldPrice: 880,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 8.5 gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/84/59/3b/84593bde6d9304a5c410889a224496fa.jpg',
    shades:[
        {
        name: 'Sugar Cookie Translucent', color: '#AFB0B3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925725-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114056-av-2202506021849308910700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cherry Blossom Cake', color: '#e8adac', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925741-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2555811-av-2202506021850547450700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pound Cake', color: '#dbb895', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925758-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114072-av-2202506021850064230700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Peach Cupcake', color: '#d99f7e', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925782-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114064-av-2202506021849420630700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Banana Bread', color: '#e0bc82', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925774-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2114080-av-2202506021850185130700-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 53, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 54, name: 'Oil-In-Water Tint Lip Stain',
    category: 'Lippies', formato: 'Liquido',
    brand: 'Gucci',gama: 'Lujo',
    price: 1180, oldPrice: 999,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 6.5ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/65/32/2b/65322bb733dbcc41579ae0ce772bff19.jpg',
    shades:[
        {
        name: '226 Emma Rosedust ', color: '#AC645B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960144-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960144-av-1-zoom.jpg?imwidth=1224'
        },
        {
        name: '217 Valeria Rose', color: '#8E322F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960151-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960151-av-1202603131416009480700-zoom.jpg?imwidth=1224'
        },
        {
        name: '415 Clara Pink', color: '#F04E75', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960177-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960177-av-1-zoom.jpg?imwidth=1224'
        },
        {
        name: '129 Paula Maple', color: '#751930', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960110-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960110-av-1202602190838073660800-zoom.jpg?imwidth=1224'
        },
        {
        name: '509 Rosso Ancora ', color: '#AD022E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960128-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960128-av-1-zoom.jpg?imwidth=1224'
        },
        {
        name: '225 Marianne Mauve', color: '#752B42', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2960136-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2960136-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 55, name: 'Glow Dewy Powder Blush',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Gucci',gama: 'Lujo',
    price: 1330, oldPrice: 1140,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2928422-av-9202512020803408910800-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: '01 - Arctic Rose', color: '#D777A6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2928422-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2928422-av-1202512020803401110800-zoom.jpg?imwidth=1224'
        },
        {
        name: '02 - Fresh Coral', color: '#F67B87', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2928414-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2928414-av-1202512021313317160800-zoom.jpg?imwidth=1224'
        },
        {
        name: '04 - Bright Pink', color: '#D5425B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2928448-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2928448-av-1202512021313084810800-zoom.jpg?imwidth=1224'
        },
        {
        name: '06 - Bright Ruby', color: '#B21133', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2928430-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2928430-av-1202512021313470920800-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 56, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 57, name: 'Flush Balm Cream Blush',
    category: 'Rubores', formato: 'Crema',
    brand: 'Merit',gama: 'Lujo',
    price: 880, oldPrice: 740,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 9gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/6e/53/d5/6e53d5ac219c3b2ed48cf6957dc98cdf.jpg ',
    shades:[
        {
        name: 'Cheeky', color: '#CB6472', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743995-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743995-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Fox', color: '#994943', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2744019-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2744019-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Apres', color: '#8D1A28', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743771-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743771-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rouge', color: '#D01F35', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743755-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743755-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Lusitano', color: '#EA5E50', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2848794-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2848794-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Le BonBon', color: '#F1639E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2842870-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2842870-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Postmodern', color: '#8E2B29', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2842888-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2842888-av-10-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 58, name: 'Hydrating Lip Balm',
    category: 'Lippies', formato: 'Balm',
    brand: 'Prada ',gama: 'Lujo',
    price: 1400, oldPrice: 1230,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 3.8gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/33/7b/d4/337bd4a2de927fc7794d1f8089658a69.jpg',
    shades:[
        {
        name: 'U001 Astral Pink', color: '#71B3D2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2786093-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2786093-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'U010 Maple', color: '#71362E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2776540-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2776540-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: '000 Universal', color: '#719474', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2755841-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2755841-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'U002 Banana Yellow', color: '#FACA23', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2876530-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2876530-av-2202506251112040210700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'U003 Wisteria Gleams', color: '#C6A3C1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2995868-main-zoom-1.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2995868-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 59, name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 60, name: 'GetSet Blur + Set Blush',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Tower 28',gama: 'Media Alta',
    price: 730, oldPrice: 620,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '4gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.tower28beauty.com/cdn/shop/files/GetSetBlush_StillLife_01_1.jpg?v=1765910852&width=1800',
    shades:[
        {
        name: 'Malibu Cooler', color: '#F4A0BF', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/MalibuCooler_PackShot_0f321d21-c564-4700-bc35-7540cba9978a.webp?v=1762139536&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-MC-QUAD.jpg?v=1753157414&width=1800'
        },
        {
        name: 'Long Beach Iced Tea', color: '#F49583', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-LB-PACKSHOT_8_1.png?v=1753157414&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-LB-QUAD.jpg?v=1753157414&width=1800'
        },
        {
        name: 'Feliz Fresca', color: '#F37EB1', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-FF-PACKSHOT_6_1.png?v=1753157414&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-FF-QUAD.jpg?v=1753157414&width=1800'
        },
        {
        name: 'Samo Spritzer', color: '#B06F77', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SAM0-PACKSHOT_10_1.png?v=1753157414&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SAMO-QUAD.jpg?v=1753157414&width=1800'
        },
        {
        name: 'Sawtelle Slushie', color: '#D35B73', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SS-PACKSHOT_4_1.png?v=1753157414&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SS-QUAD.jpg?v=1753157414&width=1800'
        },
        {
        name: 'Sunset Shirley', color: '#EF0335', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SS-PACKSHOT_5.webp?v=1753156972&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSetBlush_MalibuCooler_Quad_2ebe04f3-7f1e-40f7-8d82-406f32f19d39.jpg?v=1762139536&width=1800'
        },
        {
        name: 'Pali Punch', color: '#BF677C', stock: false,
        image: 'https://www.tower28beauty.com/cdn/shop/files/GetSet-SAM0-PACKSHOT11_2f7bbac7-3bc8-4d79-9c40-c4883b8b96d0.webp?v=1753157414&width=1800',
        swatchImage: 'https://www.tower28beauty.com/cdn/shop/files/GetSetBlush_PaliPunch_Quad_d571f58e-636f-40e6-b900-f9c7a83aea6f.png?v=1753157414&width=1800'
        },
  ]},
  {id: 61, name: 'Luminous Matte Powder Blush',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Gucci',gama: 'Lujo',
    price: 1330, oldPrice: 1140,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 5.5gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2587319-av-8202603201353305210700-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: '01 Silky Rose', color: '#EE8488', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2587319-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2587319-av-1202603201353543520700-zoom.jpg?imwidth=1224'
        },
        {
        name: '07 True Pink', color: '#ED86B0', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2660116-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2660116-av-1202603201353456130700-zoom.jpg?imwidth=1224'
        },
        {
        name: '03 Radiant Pink', color: '#E07073', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2587335-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2587335-av-1202603201353338830700-zoom.jpg?imwidth=1224'
        },
        {
        name: '09 Intense Plum', color: '#C24B5E', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2660132-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2660132-av-1202603201353513340700-zoom.jpg?imwidth=1224'
        },
        {
        name: '04 Bright Coral', color: '#E57E78', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2587343-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2587343-av-1202603201353360360700-zoom.jpg?imwidth=1224'
        },
        {
        name: '05 Rosy Beige', color: '#B1625A', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2587350-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2587350-av-1202603201353405900700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Poppy Red - Holidays', color: '#DD5660', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s3000783-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3000783-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 62, name: 'Honey Infused Lip Oil',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'Gisou ',gama: 'Alta',
    price: 850, oldPrice: 720,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 8ml',    new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://i.pinimg.com/736x/8b/16/74/8b16747bdbef723c12d2f8374cc2739c.jpg',
    shades:[
        {
        name: 'Watermelon Sugar', color: '#F19C9F', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2683464-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2683464-av-3202505081308311990700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Strawberry Sorbet', color: '#FF0042', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2683449-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2683449-av-3202505021026443660700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Bee-llini Peach', color: '#FF6159', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2858058-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2858058-av-03-zoom.jpg?imwidth=630'
        },
        {
        name: 'Milky Mocha', color: '#74544A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2914869-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2914869-av-1202508210648278450700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Raspberry Swirl ', color: '#FF607F', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2858025-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2858025-av-03-zoom.jpg?imwidth=630'
        },
        {
        name: 'Coco Cacao', color: '#8C5130', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2971265-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2971265-av-2202603091456438670700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Honey Gold', color: '#ECB941', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2820462-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2820462-av-3202505021021273300700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Cherry Chocolate', color: '#B64627', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3015534-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3015534-av-2-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 63, name: 'Chocolate Soleil',
    category: 'Bronzer', formato: 'Polvo',
    brand: 'Too Faced',gama: 'Media Alta',
    price: 1000, oldPrice: 890,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 8gr', new: false, stock: false, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/d6/74/87/d674873157e4ea2083352a16f133462f.jpg',
    shades:[
        {
        name: 'Milk Chocolate', color: '#AC6F4B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2966109-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2966109-av-2202601271419321560800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Chocolate Soleil', color: '#B66340', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2966125-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2966125-av-2202601271419104000800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Chocolate Caramel', color: '#823F24', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2966059-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2966059-av-2202601271420549270800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 64, name: 'Enchinador de pestañas',
    category: 'Ojos', formato: 'Versión USA',
    brand: 'Shiseido ',gama: 'Alta',
    price: 680, oldPrice: 630,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '',    new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/c8/b1/f5/c8b1f5b4a79ea4a69a97187f482d5e48.jpg',
    shades:[
  ]},
  /*{id: 65,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 66, name: 'Dew Blush Cream Blush',
    category: 'Rubores', formato: 'Liquido',
    brand: 'Saie',gama: 'Media Alta',
    price: 860, oldPrice: 750,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 12 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/82/8d/4f/828d4f77e92473f1d029f68a0e07970a.jpg',
    shades:[
        {
        name: 'Baby', color: '#F495BB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2742989-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2742989-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Cutie', color: '#B65B56', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2742963-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2742963-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Dreamy', color: '#992D41', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2437804-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2437804-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Spicy', color: '#832D23', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2564730-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2564730-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Chilly', color: '#B04655', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2564722-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2564722-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Sweetie', color: '#DB6B7C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2742971-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2742971-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Rosy', color: '#E78473', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2437788-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2437788-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Flirty', color: '#E74D65', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2872448-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2872448-av-3-zoom-us.jpg?imwidth=1224'
        },
  ]},
  {id: 67, name: 'Micro-Correcting con Peptidos',
    category: 'Correctores', formato: 'Liquido',
    brand: 'Prada',gama: 'Lujo',
    price: 1330, oldPrice: 1150,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 9ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2928661-av-9202512081037502880800-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Consulta tonos por DM', color: '', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2928554-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2928521-av-2202512081037339270800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 68, name: 'Pradascope Lash Mascara',
    category: 'Ojos', formato: 'Liquido',
    brand: 'Prada ',gama: 'Alta',
    price: 1000, oldPrice: 910,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 8.5ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/c7/35/ec/c735ecc71027c0d219b095dc2a40a5ec.jpg',
    shades:[
        {
        name: '01 Nero', color: '#050E15', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2836070-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2836070-av-1202603091440038860700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'B03 Mahogany', color: '#52161C', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2949691-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2949691-av-1-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 69, name: 'Rosy Glow Powder Blush',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Dior',gama: 'Lujo',
    price: 1000, oldPrice: 950,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/9b/5c/e5/9b5ce5a963a2ddd027a3d30b5b9fb413.jpg',
    shades:[
        {
        name: '001 Pink', color: '#FB89C5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2864700-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2864700-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '006 Berry ', color: '#A93D5F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2864692-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2864692-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '012 Rosewood', color: '#D76B81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2864734-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2864734-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '015 Cherry', color: '#D1444F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2864783-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2864783-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '077 Candy', color: '#E9717C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2864817-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2864817-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '109 Goji', color: '#993741', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2962363-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2962363-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 70, name: 'Backstage Concealer',
    category: 'Correctores', formato: 'Liquido',
    brand: 'Dior',gama: 'Lujo',
    price: 960, oldPrice: 780,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '10.94gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/c2/d0/49/c2d049c8fb8bf9b4875aaeae16dac182.jpg',
    shades:[
        {
        name: '1C - fair to light', color: '#E6C9B1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509552-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509552-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '3N - light to medium', color: '#F9C292', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509594-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509594-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '2N - light', color: '#E3B790', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509560-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509560-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '1N - fair to light', color: '#EECEB2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509537-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509537-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '4W - medium', color: '#E5B689', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509636-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509636-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: ' 3C - light to medium', color: '#E5BEA8', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509610-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509610-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '2W - light', color: '#EEC79C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509578-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509578-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '4N - medium', color: '#DAAB89', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2509628-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2509628-av-02-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 71, name: 'Hydrating Plumping Lip Gloss',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Gucci',gama: 'Lujo',
    price: 1180, oldPrice: 999,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 6.21ml',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2735702-av-10202603201418004370700-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: '117 - joslyn clair', color: '#fff', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735728-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735728-av-1202603201418022650700-zoom.jpg?imwidth=1224'
        },
        {
        name: '219 - bertha pink', color: '#F483A3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735702-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735702-av-1202603201418120290700-zoom.jpg?imwidth=1224'
        },
        {
        name: '18 - suzane brown', color: '#6B3E37', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735744-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735744-av-1202603201418068880700-zoom.jpg?imwidth=1224'
        },
        {
        name: '526 - teresina red', color: '#FE010F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735751-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735751-av-1202603201418092850700-zoom.jpg?imwidth=1224'
        },
        {
        name: '414 - virginia fuschia', color: '#E83157', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735736-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735736-av-1202603201418042060700-zoom.jpg?imwidth=1224'
        },
        {
        name: '135 - Laura Latte (Holidays) ', color: '#E47B68', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3000791-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3000791-av-4-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 72, name: 'Mini Dew Blush Cream Blush',
    category: 'Rubores', formato: 'Liquido',
    brand: 'Saie',gama: 'Media Alta',
    price: 550, oldPrice: 490,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 7 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/07/24/e7/0724e75469017a3f0dc77d4f234c8df5.jpg',
    shades:[
        {
        name: 'Baby', color: '#F495BB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2742989-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2742989-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Chilly', color: '#B04655', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2938744-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2564722-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Sweetie', color: '#DB6B7C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2938223-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2742971-av-3-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Lady', color: '#D5868B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2938405-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2938405-av-1202511061239235810800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 73, name: 'Mirror Case (No incluye labial)',
    category: 'Tools', formato: 'Tapa con espejo ',
    brand: 'Guerlain',gama: 'Lujo',
    price: 1140, oldPrice: 1000,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Rouge G',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/2c/05/35/2c0535c8f4e5c10cb7840925074e8c33.jpg',
    shades:[
        {
        name: 'Le Strassé', color: '#B2ADB1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807303-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807303-av-2202510200855183160700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Bleu Astral', color: '#328ED5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2991909-main-zoom-us.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2991909-av-2-zoom-us.jpg?imwidth=630'
        },
        {
        name: 'L´Art Déco', color: '#CC9B60', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807253-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807253-av-2202510200855191560700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Le Marbre', color: '#ffffff', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807295-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807295-av-2202510200855195690700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Bleu Iconique', color: '#0A2F40', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2991933-main-zoom-us.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2991933-av-2-zoom-us.jpg?imwidth=630'
        },
        {
        name: 'Les Studs', color: '#000000', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807287-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807287-av-2202510200855172990700-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 74, name: 'Ambient Lighting Edit Unlocked Palette',
    category: 'Rostro', formato: 'Polvo',
    brand: 'Hourglass ',gama: 'Lujo',
    price: 2800, oldPrice: 2500,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 1.4 g (x6)',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2988871-av-9-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Luck', color: '#9F4A4F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2988871-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2988871-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 75, name: 'Rouge G Satin & Velvet Lipstick',
    category: 'Lippies', formato: 'Barra',
    brand: 'Guerlain ',gama: 'Lujo',
    price: 1140, oldPrice: 995,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.5gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/33/d8/18/33d818cd7474c1dc58be0dd5435d9dc4.jpg',
    shades:[
        {
        name: '518 Le Rose Blush', color: '#D55C63', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807345-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807345-av-4-zoom.jpg?imwidth=630'
        },
        {
        name: '03 Le Nude Intense', color: '#B14B47', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807451-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807451-av-2202509191247280070700-zoom.jpg?imwidth=630'
        },
        {
        name: '159 Le Beige Amande ', color: '#A55346', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807170-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807170-av-2202509191251310640700-zoom.jpg?imwidth=630'
        },
        {
        name: '968 Le Lie De Vin', color: '#A42B32', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2807410-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2807410-av-2202509191335103420700-zoom.jpg?imwidth=630'
        },
        {
        name: '521 Le Grege Rose', color: '#B25757', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925956-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2925956-av-2202509191334496930700-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 76, name: 'Hand Sanitizer',
    category: 'Desinfectante', formato: 'Spray',
    brand: 'Touchland',gama: 'Media Alta', ss:true,
    price: 380, oldPrice: 310,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 30 ml', new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/9e/f0/a6/9ef0a6ed207b46dcb14b067c3771b9a7.jpg',
    shades:[
        {
        name: 'Berry Bliss', color: '#E4B6D5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556777-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556777-av-1202512101027485200800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Applelicious', color: '#688239', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556769-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556769-av-1202512101026155280800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Mango Passion', color: '#F5BE4A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2643674-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2643674-av-1202512101059083400800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Velvet Peach', color: '#FCB257', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556785-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556785-av-1202512101029127710800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Beach Coco', color: '#F5F5F5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556819-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556819-av-1202512101050483740800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Vanilla Blossom', color: '#D5D44D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556793-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556793-av-1202512101043252310800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Wild Watermelon', color: '#FA8E92', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2556751-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2556751-av-1202512101025340730800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Pure Lavender', color: '#8770AD', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2611234-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2611234-av-1202512101054444640800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Blue Sandalwood', color: '#276766', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2559649-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2559649-av-1202512101053015620800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Aloe you', color: '#95B41E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2611242-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2611242-av-1202512101057001930800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 77, name: 'Cream Blush',
    category: 'Rubores', formato: 'Crema',
    brand: 'Refy ',gama: 'Alta', ss:true,
    price: 690, oldPrice: 580,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '1.5 gr', new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/a4/6c/3c/a46c3c5e0aa66c3f6f27fb5f823d35cf.jpg',
    shades:[
        {
        name: 'Malaya', color: '#CB685E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2493906-av-3202505191134232780700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2493906-av-1202505191134233270700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cherry', color: '#932737', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2630366-av-3202505191121020040700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2630366-av-1202505191121023750700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rust', color: '#A14027', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879872-av-5202505151748164570700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879872-av-2202505151748351540700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Citrine', color: '#D4734F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2493898-av-3202505191123549480700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2493898-av-1202505191123561560700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Plum', color: '#952632', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879864-av-5202505151753551930700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879864-av-2202505151753055530700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Guava', color: '#F52C5B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2879880-av-3202505191130394010700-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2879880-av-1202505191130431090700-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 78,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 79, name: 'Pocket Bronzer',
    category: 'Bronzer', formato: 'Crema',
    brand: 'Rhode ',gama: 'Media Alta',
    price: 740, oldPrice: 645,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '5.3gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/e8/18/47/e818474c0dfd477fe68814b14c52f258.jpg',
    shades:[
        {
        name: 'sip', color: '#A16346', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2981116-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2981116-av-3202606021955153110700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'sunbed', color: '#814D33', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2981041-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2981041-av-4202606021957437730700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'bake', color: '#70351A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2981066-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2981066-av-4202606021952008910700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'shade', color: '#652B21', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2981124-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2981124-av-4202606021954020450700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 80, name: 'Satin Liquid Lipstick Pen',
    category: 'Lippies', formato: 'Cushion',
    brand: 'Refy',gama: 'Alta',
    price: 850, oldPrice: 720, ss:true,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.5 ml', new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/91/df/fd/91dffd528c6d2b2d464be8d21c74b0bf.jpg',
    shades:[
        {
        name: 'Mulberry', color: '#862D33', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2912004-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2912004-av-1202509180547374480700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Maple', color: '#844025', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2912038-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2912038-av-1202509190112168040700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rosa', color: '#944C3B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2912053-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2912053-av-1202509180544320930700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Ruby', color: '#7B2724', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2912020-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2912020-av-1202509180557173850700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Mocha', color: '#662C22', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2912046-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2912046-av-1202509190127300300700-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 81,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 82,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 83, name: 'Glossybounce Lip Gloss Oil',
    category: 'Lippies', formato: 'Gloss / Oil',
    brand: 'Saie ',gama: 'Media Alta',
    price: 780, oldPrice: 675,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full -5 ml',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/4c/b0/25/4cb025358d48ceeb8980d37b310e6f2a.jpg',
    shades:[
        {
        name: 'Play', color: '#E46A8F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691459-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691459-av-1202603161142198490700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Remix', color: '#B23846', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2790590-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2790590-av-1202603161203378240700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Bounce', color: '#BE534D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691467-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691467-av-1202603161138509290700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Dream', color: '#93164A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691483-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691483-av-1202603161204327320700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Dip', color: '#B86F5F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691442-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691442-av-1202603161145101710700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Disco', color: '#DE7375', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2790582-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2790582-av-1202603161202441720700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Push', color: '#845340', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691475-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691475-av-1202603161205393380700-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 84,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 85, name: 'Blush Filter Soft Glow',
    category: 'Rubores', formato: 'Liquido',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 730, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full  - 4.5 ml',
    new: false, stock: true, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/22/d5/c4/22d5c4f4f84e84bf94a1f5f8259ea4b9.jpg ',
    shades:[
        {
        name: 'Bubblegum', color: '#F189A1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2837169-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2837169-av-2202602101037305600800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cotton Candy', color: '#EE8674', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767309-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767309-av-2202602101037526300800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry Cream', color: '#C65353', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767317-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767317-av-2202602101038236080800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry Latte', color: '#AC4644', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2954675-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2954675-av-2202602091430496100800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Latte', color: '#8B442E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2814366-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2814366-av-2202602101038128330800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Intense Guava', color: '#E9225F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2837151-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2837151-av-2202602101038027940800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Berry Fever', color: '#AA2740', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2954659-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2954659-av-2202602091430378800800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Black Cherry', color: '#7D2132', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767283-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767283-av-2202602101036585950800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Coco-Loco', color: '#521707', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2817930-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2817930-av-2202602101037407040800-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 86,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 87,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 88,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 89, name: 'Forever Nude Jumbo Bronzer',
    category: 'Bronzers', formato: 'Polvo',
    brand: 'Dior',gama: 'Lujo',
    price: 1610, oldPrice: 1400,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '18gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/84/12/a8/8412a8eebaf9ccb96da98282667088a4.jpg',
    shades:[
        {
        name: '10 - light', color: '#E19570', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2836369-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2836369-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '20 - light to medium', color: '#D08A69', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2836377-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2836377-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '30 - medium to deep', color: '#B27B63', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2836385-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2836385-av-02-zoom.jpg?imwidth=1224'
        },
        {
        name: '40 - deep', color: '#8D4C36', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2836393-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2836393-av-07-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 90, name: 'Kissing Jelly',
    category: 'Lippies', formato: 'Gloss / Oil',
    brand: 'Too Faced',gama: 'Media Alta',
    price: 680, oldPrice: 560,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '4 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/14/fc/22/14fc2258ea3207cc5efc0230d0520fdd.jpg ',
    shades:[
        {
        name: 'Bubblegum', color: '#FD7399', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739167-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739167-av-1-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cherry Pie', color: '#DB0227', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2839348-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2839348-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Grape Soda', color: '#E85592', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739209-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739209-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cream Soda', color: '#A9553F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2885788-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2885788-av-1202505141533268120700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Raspberry', color: '#E53D7B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739225-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739225-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sour Watermelon', color: '#FB2120', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739217-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739217-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 91,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 92, name: 'Color Fuse Blush Powder',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Haus Labs',gama: 'Alta',
    price: 980, oldPrice: 850, ss:true,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '5gr',   new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/f2/8b/26/f28b268dacd4d71090c2bffe2c3cd807.jpg',
    shades:[
        {
        name: 'Hibiscus Haze', color: '#D25A79', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2760908-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2760908-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'French Rosette', color: '#B96358', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2760940-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2760940-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Watermelon Bliss', color: '#DD4465', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2760924-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2760924-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Fire Moon', color: '#A5634A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2760957-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2760957-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: 'Dragon Fruit Daze', color: '#EF6EA9', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2760916-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2760916-av-1-zoom-1.jpg?imwidth=630'
        },
  ]},
  /*{id: 93,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 94,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 95, name: 'Chocolate Soleil Stick',
    category: 'Bronzer', formato: 'Crema',
    brand: 'Too Faced ',gama: 'Media Alta',
    price: 950, oldPrice: 810,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '8.3 gr',new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/02/1c/b3/021cb39417a6ef750283697e559e8211.jpg',
    shades:[
        {
        name: 'Milk Chocolate', color: '#BE8E78', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2851608-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2851608-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Chocolate Mousse', color: '#A37160', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2772093-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2772093-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Chocolate Souffle', color: '#976049', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2772101-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2772101-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Chocolate Caramel', color: '#8F533E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2772077-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2772077-av-01-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 96,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 97, name: 'Lash Sculpt Mascara',
    category: 'Ojos', formato: 'Liquido',
    brand: 'Refy',gama: 'Alta',
    price: 850, oldPrice: 710,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 10 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://i.pinimg.com/1200x/17/56/74/175674f00fe9051c4cf3f3cb724593c7.jpg',
    shades:[
        {
        name: 'Black', color: '#0C0C0C', stock: false,
        image: 'https://scdn.speedsize.com/d2d3381f-f48a-4389-b41e-1d53123fab1b/refybeauty.com/cdn/shop/files/BLACK_USP.jpg?format=webp&v=1759406137&width=750',
        swatchImage: 'https://scdn.speedsize.com/d2d3381f-f48a-4389-b41e-1d53123fab1b/refybeauty.com/cdn/shop/files/BLACK_B_A.jpg?format=webp&v=1759406137&width=750'
        },
        {
        name: 'Brown', color: '#72574A', stock: false,
        image: 'https://scdn.speedsize.com/d2d3381f-f48a-4389-b41e-1d53123fab1b/refybeauty.com/cdn/shop/files/BROWN_USP.jpg?format=webp&v=1759406137&width=750',
        swatchImage: 'https://scdn.speedsize.com/d2d3381f-f48a-4389-b41e-1d53123fab1b/refybeauty.com/cdn/shop/files/2._BROWN_B_A.jpg?format=webp&v=1759406137&width=750'
        },
  ]},
  {id: 98,  name: 'Oil Sucker Liquid Blotting Paper Touch Up Spray',
    category: 'Fijadores', formato: ' Spray',
    brand: 'One Size',gama: 'Alta',
    price: 890, oldPrice: 760,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - 142ml',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/47/90/79/479079bd4eed1e9a41001a487cd76ecd.jpg',
    shades:[
  ]},
  /*{id: 99,
    name: '',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 100,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 101, name: 'Blush Filter Palette',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 1160, oldPrice: 995,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '7.5 gr',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/c6/19/62/c61962abc808340a1fbdd364f43f3d13.jpg ',
    shades:[
        {
        name: 'Toasty Peach', color: '#EA615F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2906345-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2906345-av-3202509091207465120700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Baby Pink', color: '#F277B5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2906329-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2906329-av-2202509091208077760700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rose Berry', color: '#CB636F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2906337-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2906337-av-2202509091207338570700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry Latte', color: '#AC555C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2954642-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2954642-av-2202602091431478460800-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 102,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 103, name: 'Triclone Foundation',
    category: 'Bases', formato: 'Cobertura Media',
    brand: 'Haus Labs',gama: 'Alta',
    price: 1490, oldPrice: 1300,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 30ml',   new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/02/e7/b1/02e7b191505985d1929260639dbd9bb2.jpg',
    shades:[
        {
        name: '070 Fair ', color: '#E3C4AC', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597458-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597458-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '100 Light', color: '#E1C2B3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597441-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597441-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '120 Light', color: '#EAC8A8', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597425-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597425-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '145 Light', color: '#CEAB85', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597409-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597409-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '190 Light', color: '#D9AF91', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597375-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597375-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '210 Light Medium', color: '#E1AC90', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597359-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597359-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '220 Light Medium', color: '#CDA793', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597342-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597342-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '250 Light Medium', color: '#D69C81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597318-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597318-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '270 Light Medium', color: '#C28F70', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597292-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597292-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '280 Light Medium', color: '#BF9680', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597284-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597284-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '300 Medium', color: '#D8AD8D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597276-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597276-av-1-zoom-1.jpg?imwidth=630'
        },
        {
        name: '310 Medium', color: '#CA9170', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2597268-main-zoom-1.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2597268-av-1-zoom-1.jpg?imwidth=630'
        },
  ]},
  /*{id: 104,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 105,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 106,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 107, name: 'Soft Pinch Liquid Contour',
    category: 'Contorno', formato: 'Liquido',
    brand: 'Rare Beauty ',gama: 'Media Alta',
    price: 840, oldPrice: 700,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 14.88 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/93/75/c1/9375c1213cf8200f69344fec4715a7ba.jpg ',
    shades:[
        {
        name: 'Mellow', color: '#BD947C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LIQUID-CONTOUR-MELLOW_1440x.jpg?v=1736878195&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/CAMPAIGN-CANDIDS-SOFT-PINCH-LIQUID-CONTOUR-MELLOW_1440x.jpg?v=1736878195&format=pjpg'
        },
        {
        name: 'Solace', color: '#A87E65', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LIQUID-CONTOUR-SOLACE_1440x.jpg?v=1737609699&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/CAMPAIGN-CANDIDS-SOFT-PINCH-LIQUID-CONTOUR-SOLACE_1440x.jpg?v=1737658942&format=pjpg'
        },
        {
        name: 'Serene', color: '#985D3B', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LIQUID-CONTOUR-SERENE_1440x.jpg?v=1737658942&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/CAMPAIGN-CANDIDS-SOFT-PINCH-LIQUID-CONTOUR-SERENE_1440x.jpg?v=1737658942&format=pjpg'
        },
        {
        name: 'Tranquil', color: '#73422C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-SOFT-PINCH-LIQUID-CONTOUR-TRANQUIL_1440x.jpg?v=1737658942&format=pjpg',
        swatchImage: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/CAMPAIGN-CANDIDS-SOFT-PINCH-LIQUID-CONTOUR-TRANQUIL_1440x.jpg?v=1737658942&format=pjpg'
        },
  ]},
  /*{id: 108,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 109, name: 'Brow Sculpt Lifting Gel',
    category: 'Cejas', formato: 'Crema',
    brand: 'Refy',gama: 'Alta',
    price: 770, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full  - 8.5 ml',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2878353-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  /*{id: 110,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 111,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 112,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 113,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 114,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 115,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 116,  name: 'Juicy Tubes Lip Gloss',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Lancôme',gama: 'Lujo',
    price: 720, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 15ml',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://www.sephora.com/productimages/sku/s2356012-av-25-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: '02 Spring Fling', color: '#EF8F90', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2356012-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2356012-av-21-zoom.jpg?imwidth=1224'
        },
        {
        name: '07 Magic Spell', color: '#A9404F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2355998-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2355998-av-21-zoom.jpg?imwidth=1224'
        },
        {
        name: '19 Cocoa Macchiato', color: '#824240', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2872562-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2872562-av-2202505151502081580700-zoom.jpg?imwidth=1224'
        },
        {
        name: '08 Tickled Pink', color: '#A7334B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2355964-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2355964-av-2202505061458559440700-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 117,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 118, name: 'Speak Love Lip-Plumping Balm',
    category: 'Lippies', formato: 'Balm',
    brand: 'LYS Beauty ',gama: 'Media Alta',
    price: 680, oldPrice: 600,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' ', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/f7/e7/04/f7e704fabd7c14b46d084d42a0f2f0e8.jpg',
    shades:[
        {
        name: 'Visionary', color: '#9B3730', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847507-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847507-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Truthful', color: '#C0615F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847499-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847499-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: 'CEO', color: '#C83F53', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847473-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847473-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Diva', color: '#FB3F79', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847465-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847465-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Genius', color: '#74303C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2847515-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2847515-av-11-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 119,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 120, name: 'Atomic Shake Lip Lacquer',
    category: 'Lippies', formato: 'Liquido',
    brand: 'Haus Labs',gama: 'Alta',
    price: 860, oldPrice: 750,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 4ml',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/d2/5b/2f/d25b2fae5a0ee12283dbd9b506fe8be9.jpg',
    shades:[
        {
        name: 'Maroon', color: '#632137', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977890-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977890-av-1202603112040270280700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Berry', color: '#8D1C57', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977882-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977882-av-1202603112040180170700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Dusty Rose', color: '#A94B5D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977841-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977841-av-1202603112039304140700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ruby', color: '#B51F2D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977866-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977866-av-1202603112040014430700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sheer Sienna', color: '#7A473F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977833-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977833-av-1202603112039213820700-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sheer Blush', color: '#9C5858', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2977874-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2977874-av-1202603112040099900700-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 121, name: 'Spotwear',
    category: 'Rostro', formato: 'Parches ',
    brand: 'Rhode',gama: 'Media Alta',
    price: 495, oldPrice: 420,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '36 parches',
    new: false, stock: true,ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.rhodeskin.com/cdn/shop/files/spotwear-strawberry-hero4-desktop_2480x.jpg?v=1791238002',
    shades:[
        {
        name: 'Strawberry', color: '#CF112C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3009271-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3009271-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 122,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 123, name: 'Faux Filler Shiny Gloss',
    category: 'Lippies', formato: 'Gloss',
    brand: 'Huda Beauty',gama: 'Alta',
    price: 640, oldPrice: 560,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3.9 ml',
    new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/22/83/f0/2283f0e2d6c118cd8a02ef661a858d26.jpg ',
    shades:[
        {
        name: 'Sugar Baby', color: '#F27D84', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739480-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739480-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Bombshell', color: '#9C3D3D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739472-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739472-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: 'RichCealer', color: '#D16F55', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2954667-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2954667-av-2202602170725385460800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Foxy', color: '#B0422B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2739514-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2739514-av-3-zoom.jpg?imwidth=1224'
        },
        {
        name: 'She Fire', color: '#673333', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2814358-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2814358-av-02-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 124, name: 'Honey Infused Hair Oil',
    category: 'Cabello', formato: 'Oil',
    brand: 'Gisou',gama: 'Alta',
    price: 1250, oldPrice: 1070,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 50ml',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/67/4d/b9/674db9e776bcf2ab52c9f0aaf1c4d8e8.jpg ',
    shades:[
  ]},
  /*{id: 125,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 126, name: 'Signature Lip Blush',
    category: 'Lippies', formato: 'Barra',
    brand: 'Merit',gama: 'Lujo',
    price: 820, oldPrice: 700,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 3gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/23/18/36/231836bf77f1a5323f5b57121090a324.jpg',
    shades:[
        {
        name: 'Bespoke', color: '#76463F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945087-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945087-av-1202512081541308150800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Vendôme', color: '#B46956', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945111-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945111-av-1202512081542409220800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Archival', color: '#C2626E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945186-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945186-av-1202512081541050550800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Framboise', color: '#B74153', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945012-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945012-av-1202512081541430480800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'September', color: '#9C2C2B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945095-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945095-av-1202512081542306360800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Andie', color: '#D97A82', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945061-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945061-av-1202512081540529050800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Gamay', color: '#A74747', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945194-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945194-av-1202512081541548700800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Kitten Heel', color: '#D04E42', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2945160-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2945160-av-1202512081542086110800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 127, name: 'Sunkissed Glow Bronzer Powder',
    category: 'Bronzers', formato: 'Polvo',
    brand: 'YSL',gama: 'Lujo',
    price: 1600, oldPrice: 1400,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/23/fc/92/23fc92ef40ede054006d49cc00dc734b.jpg',
    shades:[
        {
        name: '1 - sepia', color: '#E4A181', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2751618-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2751618-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 - dune', color: '#DD9F72', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2751485-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2751485-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '3 - medina', color: '#BB784A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2751360-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2751360-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '4 - sandalwood', color: '#C5774E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2751444-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2751444-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: '5 - sienna', color: '#AB6445', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2751428-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2751428-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 128, name: 'The Minimalist Concealer Stick',
    category: 'Correctores', formato: 'Crema',
    brand: 'Merit',gama: 'Lujo',
    price: 1060, oldPrice: 920,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6.5gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/dc/52/2a/dc522a0bdd09e06eeffa61fd9f591552.jpg',
    shades:[
        {
        name: 'Chiffon', color: '#E8CEBA', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2791929-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2791929-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Silk', color: '#DEC0A4', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743805-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743805-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Bone', color: '#D0B7A8', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743797-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743797-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Cream', color: '#E4BE98', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743813-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743813-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ochre', color: '#DAAD83', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743854-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743854-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Bisque', color: '#D2AB82', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743862-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743862-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sand', color: '#E0AC80', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743870-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743870-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Suede', color: '#C18C65', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2743896-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2743896-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Jute', color: '#B88F77', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2791903-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2791903-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Palomino', color: '#DDAE8C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2791895-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2791895-av-01-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 129, name: 'Major Glow Highlighter Duo',
    category: 'Iluminadores', formato: 'Crema & Polvo',
    brand: 'Patrick Ta',gama: 'Alta',
    price: 1180, oldPrice: 1040,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/39/83/69/398369d4d5f05a7adc8dc42f92e7c20e.jpg',
    shades:[
        {
        name: 'Baby', color: '#E8ACBD', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2779718-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2779718-av-1202505291637427420700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'My Love', color: '#CBC5BD', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2779734-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2779734-av-1202505291654119980700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sugar', color: '#E0B3A1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2779726-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2779726-av-1202505291652430690700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Honey', color: '#D69B7C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2787638-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2787638-av-1202505291655555920700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 130, name: 'Prisme Libre Loose Powder',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'Givenchy',gama: 'Lujo',
    price: 1580, oldPrice: 1340,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 10gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/6a/86/a4/6a86a4d4451873dbc324043c7ea364f5.jpg',
    shades:[
        {
        name: '01 Mousseline Pastel', color: '#BDA3CB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788586-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788586-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: '02 Satin Blanc', color: '#D0A594', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788594-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788594-av-5-zoom.jpg?imwidth=1224'
        },
        {
        name: '03 Voile Rose', color: '#DC9B9B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788602-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788602-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: '04 - Mousseline Acidulee', color: '#E69254', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788610-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788610-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: '05 Popeline Mimosa', color: '#BD7556', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788628-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788628-av-5-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 131, name: 'Mini Prisme Libre Loose Powder',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'Givenchy',gama: 'Lujo',
    price: 950, oldPrice: 790,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 3gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/42/0c/cd/420ccdf05f06a176628a6f3f8b1b7650.jpg',
    shades:[
        {
        name: '01 Mousseline Pastel', color: '#BDA3CB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788529-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788586-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: '02 Satin Blanc', color: '#D0A594', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788537-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788594-av-5-zoom.jpg?imwidth=1224'
        },
        {
        name: '03 Voile Rose', color: '#DC9B9B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788545-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788602-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: '04 - Mousseline Acidulee', color: '#E69254', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788552-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788610-av-4-zoom.jpg?imwidth=1224'
        },
        {
        name: '05 Popeline Mimosa', color: '#BD7556', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2788560-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2788628-av-5-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 132, name: 'Lash Curler',
    category: 'Ojos', formato: '',
    brand: 'Dior',gama: 'Lujo',
    price: 880, oldPrice: 730,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2244440-main-zoom.jpg?imwidth=1224 ',
    shades:[
  ]},
  /*{id: 133,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 134, name: 'Go Off Makeup Remover Dissolving Mist',
    category: 'Fijadores', formato: 'Spray',
    brand: 'One Size',gama: 'Alta',
    price: 880, oldPrice: 750,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - 115ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2876258-av-10-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 135, name: 'Mini On Til Dawn Mattifying Waterproof Setting Spray',
    category: 'Fijadores', formato: 'Spray',
    brand: 'One Size',gama: 'Alta',
    price: 550, oldPrice: 490,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 46ml',  new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2490704-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 136, name: 'Mini Oil Sucker Liquid Blotting Paper Touch Up Spray',
    category: 'Fijadores', formato: 'Spray',
    brand: 'One Size',gama: 'Alta',
    price: 590, oldPrice: 510,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 45ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://www.sephora.com/productimages/sku/s2975373-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 137, name: 'Bio-Radiant Highlighter',
    category: 'Iluminadores', formato: 'Gel-Polvo',
    brand: 'Haus Labs',gama: 'Alta',
    price: 1140, oldPrice: 999,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '8.5gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/c7/1f/8f/c71f8fc0eb7ea38fac1545d37d703eef.jpg',
    shades:[
        {
        name: 'Peach Quartz', color: '#E19D8E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2572576-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2572576-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Rose Quartz', color: '#D97C93', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2572626-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2572626-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Pink Amethyst ', color: '#E88677', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2572584-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2572584-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Moonstone', color: '#D4D6E1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2572634-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2572634-av-1-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 138, name: 'Shade Slick Tinted Lip Oil',
    category: 'Lippies', formato: 'Lip Oil',
    brand: 'Merit',gama: 'Lujo',
    price: 750, oldPrice: 640,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '7ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/c0/fe/2e/c0fe2e9a73da7a471c0a32f2c8575b2c.jpg',
    shades:[
        {
        name: 'Les Deux', color: '#FE3764', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2675478-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2675478-av-23-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sangria', color: '#873332', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2426757-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2426757-av-004-zoom.jpg?imwidth=630'
        },
        {
        name: 'Maraschino', color: '#D21F01', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2675494-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2675494-av-20-zoom.jpg?imwidth=630'
        },
        {
        name: 'Tabby', color: '#60281B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2849909-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2849909-av-01-zoom.jpg?imwidth=630'
        },
        {
        name: 'Pink Beet', color: '#AA443F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2426740-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2426740-av-004-zoom.jpg?imwidth=630'
        },
        {
        name: 'Pointelle', color: '#EE6987', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2849891-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2849891-av-01-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 139, name: 'Loveshine Plumping Lip Oil Gloss',
    category: 'Lippies', formato: 'Oil Gloss',
    brand: 'YSL',gama: 'Lujo',
    price: 1060, oldPrice: 940,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 6ml',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/b7/ad/19/b7ad19056f8c9520aca9a65612568296.jpg',
    shades:[
        {
        name: '44 Nude Lavalliere', color: '#C2666E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830172-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830172-av-1202603311104187420700-zoom.jpg?imwidth=1224'
        },
        {
        name: '04 Honey Pure Love', color: '#984B3E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830115-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830115-av-1202603311104036360700-zoom.jpg?imwidth=1224'
        },
        {
        name: '07 Strawberry Star', color: '#D52E3C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830149-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830149-av-1202603311104099210700-zoom.jpg?imwidth=1224'
        },
        {
        name: '08 Purple Dream', color: '#5E1826', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830156-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830156-av-1202603311104140320700-zoom.jpg?imwidth=1224'
        },
        {
        name: '13 Cold Brew Craze', color: '#9A664C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2999449-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2999449-av-1-zoom.jpg?imwidth=1224'
        },
        {
        name: '05 California Sunshine ', color: '#BA4F1D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830123-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830123-av-1202603311104059220700-zoom.jpg?imwidth=1224'
        },
        {
        name: '06 Espresso Stardust', color: '#4F2122', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2830131-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2830131-av-1202603311104083000700-zoom.jpg?imwidth=1224'
        },
        {
        name: '12 Honeymoon', color: '#CF6D4F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935229-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935229-av-1202601061641350400800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 140, name: 'Warm Wishes Matte Powder Bronzer',
    category: 'Bronzer', formato: 'Polvo',
    brand: 'Rare Beauty',gama: 'Media Alta',
    price: 860, oldPrice: 750,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 9gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/de/43/33/de433326cf275eab53737eeec310aa25.jpg',
    shades:[
        {
        name: 'Summer Feels', color: '#E4A98A', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-WW-POWDER-BRONZER-SUMMER-FEELS_1440x.jpg?v=1767661488&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2936383-av-2202511201724438270800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sun Blaze', color: '#CB916B', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-WW-POWDER-BRONZER-SUN-BLAZE_1440x.jpg?v=1767661584&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2936342-av-2202511201723372030800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Warmed Up', color: '#CA9675', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-WW-POWDER-BRONZER-WARMED-UP_1440x.jpg?v=1767661641&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2936284-av-2202511201831000650800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sunny Spirits', color: '#B97D5C', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-WW-POWDER-BRONZER-SUNNY-SPIRITS_1440x.jpg?v=1767662567&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2936417-av-2202511201831013520800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Radiate Warmth', color: '#8B5C4A', stock: false,
        image: 'https://cdn.shopify.com/s/files/1/0314/1143/7703/files/ECOMM-WW-POWDER-BRONZER-RADIATE-WARMTH_1440x.jpg?v=1767662696&format=pjpg',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2936292-av-2202511201724434150800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 141, name: 'Airbrush Flawless Finish',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'Charlotte Tilbury',gama: 'Alta',
    price: 1480, oldPrice: 1310, ss:true,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 8gr', new: false, stock: false,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/45/c0/78/45c078652a00eef42620d6f480a368bf.jpg',
    shades:[
        {
        name: '1 Fair', color: '#F4DEC6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2606085-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2606085-av-3202509030628510640700-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 Medium', color: '#EBC4A2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2605988-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2605988-av-3202509030629128780700-zoom.jpg?imwidth=1224'
        },
        {
        name: '3 Tan', color: '#E89E6C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2605996-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2605996-av-3202509030629259210700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 142, name: 'Forever Skin Foundation Stick',
    category: 'Bases', formato: 'Crema Stick',
    brand: 'Dior',gama: 'Lujo',
    price: 1490, oldPrice: 1250,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '10gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/d0/cf/a9/d0cfa90db1b6e4f4f59ec963e86bbf9e.jpg',
    shades:[
        {
        name: '0.5 N Neutral', color: '#EFCCB5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2882611-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2882611-av-2202507030657221840700-zoom.jpg?imwidth=1224'
        },
        {
        name: '1 W Warm', color: '#E8D1B9', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2789154-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2789154-av-12-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 N Neutral', color: '#F5D7C1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2789188-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2789188-av-14-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 W Warm', color: '#E8D0B6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2789196-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2789196-av-16-zoom.jpg?imwidth=1224'
        },
        {
        name: '3 N Neutral', color: '#EEC099', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2789212-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2789212-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '3W Warm', color: '#F5C398', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2882561-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2882561-av-2202507030657234680700-zoom.jpg?imwidth=1224'
        },
        {
        name: '4 N Neutral', color: '#E69E62', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2789220-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2789220-av-12-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 143,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 144, name: 'Slip Tint SPF 35 Foundation',
    category: 'Bases', formato: 'Liquido',
    brand: 'Saie',gama: 'Media Alta',
    price: 1150, oldPrice: 1010,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '40 ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/43/ea/c9/43eac9df6e386e59dded9ef70119b786.jpg',
    shades:[
        {
        name: 'One', color: '#ECB9A3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2497477-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2497477-av-1202605281247229110700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Two', color: '#EBB798', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2497485-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2497485-av-1202605281303168090700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Three + Half', color: '#D39C73', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2437721-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2437721-av-1202604021019515130700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Four + Half', color: '#D49871', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2486470-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2486470-av-1202604021034134530700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Five', color: '#C08A66', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2497493-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2497493-av-1202605281306232310700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 145, name: 'Signature Lightweight Lipstick',
    category: 'Lippies', formato: 'Barra',
    brand: 'Merit',gama: 'Lujo',
    price: 820, oldPrice: 700,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '3gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/08/a3/76/08a376ae6756958a021f3ac46f56afdd.jpg',
    shades:[
        {
        name: 'Ginger', color: '#BF6050', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2792802-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2792802-av-9-zoom.jpg?imwidth=1224'
        },
        {
        name: '1990', color: '#793B30', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2546232-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2546232-av-12-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Baby', color: '#B25D59', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2512762-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2512762-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: ' L´avenue', color: '#851F17', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2512747-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2512747-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Millennial', color: '#DC7581', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2512754-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2512754-av-12-zoom.jpg?imwidth=1224'
        },
  ]},
  /*{id: 146,
    name: '',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 147,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 148,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 149,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 150,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 151,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 152, name: 'Dual Ended Precision Brush',
    category: 'Tools', formato: '',
    brand: 'Patrick Ta',gama: 'Alta',
    price: 1330, oldPrice: 1150,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Para aplicar rubor',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2711653-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  /*{id: 153,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 154, name: 'Honey Gloss Ceramide Hair Mask',
    category: 'Cabello', formato: 'Mascarilla',
    brand: 'Gisou ',gama: 'Alta',
    price: 1200, oldPrice: 1020,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 230ml',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2832954-main-zoom.jpg?imwidth=1224 ',
    shades:[
  ]},
  {id: 155, name: 'Airbrush Flawless Blush Blur',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Charlotte Tilbury ',gama: 'Alta',
    price: 1190, oldPrice: 995,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '8gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/7e/ed/01/7eed011a282677b966dd1e0c11b4c25d.jpg',
    shades:[
        {
        name: 'Pillow Talk Dreams', color: '#6E332B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2993749-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2993749-av-2-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Loved Up', color: '#EA7895', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2993756-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2993756-av-2-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Summer Lovegasm', color: '#CB725D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2993673-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2993673-av-2-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Pillow Talk', color: '#D9897D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2993814-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2993814-av-2-zoom-us.jpg?imwidth=1224'
        },
        {
        name: 'Ectasty', color: '#F5978E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2993657-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2993657-av-2-zoom-us.jpg?imwidth=1224'
        },
  ]},
  {id: 156, name: 'Blush Prisme Libre Loose Powder',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Givenchy',gama: 'Lujo',
    price: 1260, oldPrice: 1070,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 4.25gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/64/5a/bd/645abd8e70ac321ddad3b1061db5f9b9.jpg',
    shades:[
        {
        name: '1 - Mousseline Lilas', color: '#F188B0', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691178-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691178-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 - Taffetas Rosé ', color: '#E97189', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691186-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691186-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: '3 - Voile Corail', color: '#ED7165', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691194-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691194-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '4 - Organza Sienne', color: '#C96C65', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691202-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691202-av-11-zoom.jpg?imwidth=1224'
        },
        {
        name: '5 - Popeline Violine', color: '#B7465E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691210-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691210-av-10-zoom.jpg?imwidth=1224'
        },
        {
        name: '6 - Flanelle Rubis', color: '#C0373A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2691228-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2691228-av-10-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 157, name: 'Brewed Reflections Couture Face Palette',
    category: 'Rubores', formato: 'Polvo',
    brand: 'YSL',gama: 'Lujo',
    price: 2380, oldPrice: 2170,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6 x 2.81 gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/02/af/09/02af098cf7f9e5614dd90afa2bb43617.jpg',
    shades:[
        {
        name: '2 - medium to deep', color: '#AE535E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2999415-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2999415-av-5-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 158, name: 'Ultimate Blurring Setting Powder',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'One Size ',gama: 'Alta',
    price: 980, oldPrice: 820,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 34.5gr',  new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.onesizebeauty.com/cdn/shop/files/USP_ingredients_928_x_1160.jpg?v=1785212412&width=2048 ',
    shades:[
        {
        name: 'Universal Translucent', color: '#E9CDA4', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2396257-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2396257-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ultra Peach', color: '#DE8984', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2782852-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2782852-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ultra Pink', color: '#E86B81', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2656304-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2656304-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sweet Honey', color: '#ECB279', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2656312-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2656312-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Baby Pink', color: '#E1C4D2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994051-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994051-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Matcha', color: '#5D7249', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994077-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994077-av-1-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 159, name: 'Mini Ultimate Blurring Setting Powder',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'One Size ',gama: 'Alta',
    price: 590, oldPrice: 490,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 6.5gr',   new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://i.pinimg.com/736x/fa/ff/09/faff09666efc3bd420ac9db084541ffe.jpg',
    shades:[
        {
        name: 'Universal Translucent', color: '#E9CDA4', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2396257-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2396257-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ultra Peach', color: '#DE8984', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2782852-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2782852-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Ultra Pink', color: '#E86B81', stock: true,
        image: 'https://www.sephora.com/productimages/sku/s2656304-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2656304-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Sweet Honey', color: '#ECB279', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2656312-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2656312-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Baby Pink', color: '#E1C4D2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994051-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994051-av-1-zoom.jpg?imwidth=630'
        },
        {
        name: 'Matcha', color: '#5D7249', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994077-main-zoom.jpg?imwidth=630',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994077-av-1-zoom.jpg?imwidth=630'
        },
  ]},
  {id: 160, name: 'Honey Gloss Collagen Drops Hair Oil',
    category: 'Cabello', formato: 'Aceite',
    brand: 'Gisou',gama: 'Alta',
    price: 760, oldPrice: 660,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 20ml',new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2978906-av-12202603250716358160700-zoom.jpg?imwidth=1224 ',
    shades:[
  ]},
  /*{id: 161,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 162,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 163,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 164,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},
  {id: 165,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 166, name: 'Higher Glow Blush Stick',
    category: 'Rubores', formato: 'Crema',
    brand: 'LYS Beauty',gama: 'Media Alta',
    price: 720, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6.2 gr',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/60/ab/d5/60abd578d0d93562eb16b72c2e3d3c79.jpg ',
    shades:[
        {
        name: 'Elite', color: '#C3768E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735868-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735868-av-11202603271310493620700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Focused', color: '#B95658', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735918-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735918-av-11202603271310548020700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Outgoing', color: '#DF3F75', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735892-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735892-av-11202603271310338390700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Bubbly', color: '#E96B80', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735850-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735850-av-11202603271310331200700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Curvy', color: '#DF695A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735876-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735876-av-11202603271310488920700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Unfazed', color: '#B53248', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2735884-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2735884-av-11202603271309546690700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 167, name: 'Diamond Bomb Veil',
    category: 'Iluminador', formato: 'Polvo',
    brand: 'Fenty Beauty',gama: 'Media Alta',
    price: 1240, oldPrice: 980,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '8 gr',new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/d6/79/c7/d679c77262c5d24d8843d4b8c7a31bb4.jpg',
    shades:[
        {
        name: 'How Many Carats?!', color: '#EAEAEA', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2113033-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2113033-av-001-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Rosé Rave', color: '#C77264', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2385169-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2385169-av-001-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 168, name: 'Mini Airbrush Setting Spray',
    category: 'Fijadores', formato: 'Liquido',
    brand: 'Charlotte Tilbury',gama: 'Alta',
    price: 1000, oldPrice: 800,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '2 Mini x  34ml', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s3020526-main-zoom-2.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 169, name: 'Major Tinted Lip Balm',
    category: 'Lippies', formato: 'Balm',
    brand: 'Patrick Ta',gama: 'Alta',
    price: 750, oldPrice: 640,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 15gr',   new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/2f/eb/d2/2febd2bdd901f5facafad3388ec14c08.jpg',
    shades:[
        {
        name: 'Pink Salted Caramel', color: '#F891A6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925691-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2925691-av-1202601291354067220800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Milk Tea', color: '#AF8B7A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925659-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2925659-av-1202601291354103450800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Cookie Butter', color: '#A16668', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925667-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2925667-av-1202601291354123600800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Espresso', color: '#5E2A2C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2925683-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2925683-av-1202601291354066470800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Strawberry Shortcake - Ed. Limitada', color: '#DD5778', stock: true,
        image: 'https://patrickta.com/cdn/shop/files/Major-Moisture-Smoothing-Lip-Balm-Strawberry_1.jpg?v=1788560806&width=1600',
        swatchImage: 'https://patrickta.com/cdn/shop/files/PTB_Lip_Balm_Ppage_Macro_Strawberry_Shortcake_1.jpg?v=1784221416&width=1600'
        },
  ]},
  {id: 170, name: 'Water Blush Cushion',
    category: 'Rubores', formato: 'Cushion',
    brand: 'Refy',gama: 'Alta',
    price: 750, oldPrice: 640,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '7 gr',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/236x/3d/78/65/3d7865568571b7e6470386b0098a76ca.jpg',
    shades:[
        {
        name: 'Lychee', color: '#E74B4C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2969715-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2969715-av-4202605060853081760700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Acai', color: '#71362E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2969681-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2969681-av-4202605060856453380700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Apricot', color: '#F07D6A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2969749-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2969749-av-4202605060855317630700-zoom.jpg?imwidth=1224'
        },
        
  ]},
  /*{id: 171,
    name: 'a',
    category: 'b', formato: 'c',
    brand: 'd ',gama: '',
    price: 0, oldPrice: 0,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full Size - ml',
    new: false, stock: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' ',
    shades:[
        {
        name: 'e', color: '#', stock: true,
        image: 't',
        swatchImage: ''
        },
        {
        name: 'f', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'g', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
        {
        name: 'h', color: '#', stock: true,
        image: '',
        swatchImage: ''
        },
  ]},*/
  {id: 172, name: 'Peptide Lip Shape',
    category: 'Lippies', formato: 'Crema',
    brand: 'Rhode',gama: 'Media Alta',
    price: 750, oldPrice: 640,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '0.75gr',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/3e/77/fc/3e77fc1f8f18fd49c8aac0576e14185a.jpg',
    shades:[
        {
        name: 'Press', color: '#CD5B64', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2896108-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896108-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Squeeze', color: '#C08878', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3009289-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3009289-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Bend', color: '#CC7E67', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895985-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895985-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Lunge', color: '#B7685A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2896074-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2896074-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Balance', color: '#876255', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895878-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895878-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Lean', color: '#9E4F3F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2895803-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2895803-av-2-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Jump', color: '#8B6558', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3009305-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s3009305-av-2-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 173, name: 'Blush is Life Baked ',
    category: 'Rubores', formato: 'Polvo',
    brand: 'Kosas',gama: 'Media Alta',
    price: 890, oldPrice: 780,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 4.5 gr', new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: ' https://i.pinimg.com/1200x/48/c1/82/48c182e4c27ef96bfde4241468f21671.jpg',
    shades:[
        {
        name: 'Hype', color: '#F57484', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767507-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767507-av-1202505192117397630700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Butterflies', color: '#FA6AA1', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767465-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767465-av-1202505192116502650700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Adrenaline', color: '#B63B5B', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767531-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767531-av-1202505192116283380700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Thrill', color: '#CB584C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767523-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767523-av-1202505192118085410700-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Euphoria', color: '#AC476D', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2767481-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2767481-av-1202505192117247880700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 174, name: 'Lip Plumper Gloss',
    category: 'Lippies', formato: 'Lip Gloss',
    brand: 'Kosas ',gama: 'Media Alta',
    price: 780, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Full  - 12 ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2935922-av-10202602090922145850800-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: 'Aura Flare', color: '#F2A4C3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935922-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935922-av-1202602090923326640800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Aftershock', color: '#B53E58', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935914-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935914-av-1202602090923144560800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Soulfire', color: '#410703', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935971-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935971-av-1202602090923365230800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Sixth Sense', color: '#713120', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935906-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935906-av-1202602090923347430800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Unspoker', color: '#AFAEBA', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2935849-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2935849-av-1202602090923356480800-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 175, name: 'Mini CitySet Setting Spray ',
    category: 'Fijadores', formato: 'Spray',
    brand: 'Saie ',gama: 'Media Alta',
    price: 620, oldPrice: 570,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Mini - 95 ml',
    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/736x/ba/da/bc/badabcfc1568a8421c4f743a5cb3f467.jpg',
    shades:[
  ]},
  {id: 176, name: 'Super Creamy Concealer',
    category: 'Corrector', formato: 'Liquido',
    brand: 'Kosas',gama: 'Media Alta',
    price: 980, oldPrice: 890,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' Full - 5.3 ml', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/e7/3f/1e/e73f1e1308d6a4be9a17129e04789cae.jpg ',
    shades:[
        {
        name: 'Tone 02 W', color: '#FCDFC2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2333730-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2333730-av-1202512161530269830800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 03 W', color: '#EDD0B2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2333748-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2333748-av-1202512161530545040800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 3.5 W', color: '#E5C0A6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2333755-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2333755-av-1202512161531085370800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 04 N', color: '#E2C9AC', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2333763-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2333763-av-1202512161531227280800-zoom.jpg?imwidth=1224'
        },
        {
        name: ' Tone 05 W', color: '#EECCA5', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2333771-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2333771-av-1202512161531475070800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 5.3 C ', color: '#EDC3AB', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2737377-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2737377-av-1202512161541118270800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 5.8 N', color: '#FACCA3', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2737385-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2737385-av-1202512161541050370800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 6.2 N', color: '#D89E7A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2429504-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2429504-av-1202512161536367010800-zoom.jpg?imwidth=1224'
        },
        {
        name: 'Tone 6.8 W', color: '#E4A572', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2429520-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2429520-av-1202512161537165550800-zoom.jpg?imwidth=1224'
        },
        
  ]},
  {id: 177, name: 'Air Brow Lifting Eyebrow Gel',
    category: 'Cejas', formato: 'Gel',
    brand: 'Kosas',gama: 'Media Alta',
    price: 770, oldPrice: 650,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '4 gr', new: false, stock: true, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2429579-main-zoom.jpg?imwidth=1224 ',
    shades:[
  ]},
  {id: 178, name: 'Born Star Eyeshadow',
    category: 'Ojos', formato: 'Crema a Polvo',
    brand: 'Marc Jacobs',gama: 'Lujo',
    price: 880, oldPrice: 750,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '1.5 gr', new: false, stock: false,ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://i.pinimg.com/1200x/92/50/01/92500157175994eb2cf58d3315e6573b.jpg',
    shades:[
        {
        name: '230 Serving - Metallic', color: '#AC7887', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994390-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994390-av-1202604241049163740700-zoom.jpg?imwidth=1224'
        },
        {
        name: '170 Thats Cute - Metallic', color: '#E0628F', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994622-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994622-av-1202604241050198470700-zoom.jpg?imwidth=1224'
        },
        {
        name: '130 Hater - Matte', color: '#6B463C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994259-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994259-av-1202604241050099350700-zoom.jpg?imwidth=1224'
        },
        {
        name: '150 Spicy - Metallic', color: '#CD927A', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994572-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994572-av-1202604241050106580700-zoom.jpg?imwidth=1224'
        },
        {
        name: '210 Clapback - Metallic ', color: '#BA506C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994549-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994549-av-1202604241049298420700-zoom.jpg?imwidth=1224'
        },
        {
        name: '120 Delete That - Matte', color: '#783D3C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994341-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994341-av-1202604241049595930700-zoom.jpg?imwidth=1224'
        },
        {
        name: '100 On Brand - Matte ', color: '#B67766', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994952-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994952-av-1202604241050008610700-zoom.jpg?imwidth=1224'
        },
        {
        name: '140 Shady - Metallic', color: '#D39F96', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2994705-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2994705-av-1202604241050477220700-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 179, name: 'Major Skin Hydra-Luxe Foundation',
    category: 'Bases', formato: 'Liquido',
    brand: 'Patrick Ta',gama: 'Alta',
    price: 1510, oldPrice: 1380,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: ' 30ml',    new: false, stock: false, ss:true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2793578-av-09-zoom.jpg?imwidth=1224',
    shades:[
        {
        name: '4 Golden', color: '#F1D5BC', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2793602-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2793602-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: '8 Golden', color: '#EFC09E', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2793578-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2793578-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: '10 Neutral', color: '#DAAB91', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2793586-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2793586-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: '13 Olive', color: '#D09E76', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2793537-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2793537-av-01-zoom.jpg?imwidth=1224'
        },
        {
        name: '15 Golden Neutral', color: '#C48F62', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2793800-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2793800-av-01-zoom.jpg?imwidth=1224'
        },
  ]},
  {id: 180,  name: 'Pocket Brush Double-Ended ',
    category: 'Tools', formato: '',
    brand: 'Rhode ',gama: '',
    price: 840, oldPrice: 700,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Para Rubor y brozer', new: false, stock: false, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2991743-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 181,  name: 'Peptide Eye Prep Patches',
    category: 'Rostro', formato: 'Mask',
    brand: 'Rhode ',gama: 'Media Alta',
    price: 750, oldPrice: 620,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '6 pares', new: false, stock: false, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2908697-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 182,  name: 'Mini Bubble Bag',
    category: 'Rostro', formato: 'Bolso',
    brand: 'Rhode ',gama: 'Media Alta',
    price: 1050, oldPrice: 940,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: '24 x 18 x 6 cm', new: false, stock: false, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s3025517-main-zoom.jpg?imwidth=1224',
    shades:[
  ]},
  {id: 183,  name: 'Mini Airbrush Flawless Finish',
    category: 'Fijadores', formato: 'Polvo',
    brand: 'Charlotte Tilbury ',gama: 'Media Alta',
    price: 830, oldPrice: 720,
    rating: 5.0, bestseller: true, discount: 'prueba',
    tam: 'Mini - 3.4 gr', new: false, stock: false, ss: true,
    pventa: 'harmony', pickup:'', pickStore:'',
    image: 'https://www.sephora.com/productimages/sku/s2407328-av-05-zoom.jpg?imwidth=1224',
    shades:[
      {
        name: '1 Fair', color: '#F4DEC6', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2606085-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2606085-av-3202509030628510640700-zoom.jpg?imwidth=1224'
        },
        {
        name: '2 Medium', color: '#EBC4A2', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2605988-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2605988-av-3202509030629128780700-zoom.jpg?imwidth=1224'
        },
        {
        name: '3 Tan', color: '#E89E6C', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s2605996-main-zoom.jpg?imwidth=1224',
        swatchImage: 'https://www.sephora.com/productimages/sku/s2605996-av-3202509030629259210700-zoom.jpg?imwidth=1224'
        },
  ]},




]